<template>
  <div class="animated fadeIn worksheet">
    <div class="card">
      <div class="main-card-body">
        <!-- Start banner -->
        <!-- <Banner /> -->
        <!-- End banner -->
        <h4 class="mb-4 bold">Bảng chấm công</h4>
        <el-form
          ref="myFormSearch"
          label-position="left"
          @submit.native.prevent
          label-width="125px"
          :model="mData.tableRules.dataSearch.value"
          :rules="mData.tableRules.dataSearch.valid"
        >
          <div>
            <div class="main-body__filter-button d-flex justify-content-between">
              <div class="d-flex at-center">
                <div class="mr-3">
                  <el-form-item label="Kỳ tháng">
                    <el-select
                      class="salary_period"
                      v-model="mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id"
                      @change="fn_changeSalaryPeriod"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listSalaryPeriod"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <p class="status">
                  Trạng thái:
                  <span class="bold" style="color: var(--orange) !important;">
                    {{
                      mData.workSealedStatus === false
                        ? "Chưa chốt"
                        : mData.workSealedStatus === true
                        ? "Đã chốt"
                        : ""
                    }}
                  </span>
                </p>
              </div>
              <div class="text-right">
                <div class="text-right button-div">
                  <el-button
                    type="success"
                    plain
                    round
                    class="btn-default"
                    v-if="
                      mData.timeView == 'month' &&
                        mData.dataDefault.listFeature.includes('FT803') &&
                        mData.workSealedStatus === false
                    "
                    @click="fn_submit('approve')"
                  >
                    Chốt bảng công
                  </el-button>
                  <el-button
                    type="danger"
                    round
                    plain
                    class="btn-radius-10"
                    v-if="
                      mData.timeView == 'month' &&
                        mData.dataDefault.listFeature.includes('FT803') &&
                        mData.workSealedStatus === true
                    "
                    @click="fn_submit('un_approve')"
                  >
                    Bỏ chốt bảng công
                  </el-button>
                  <el-button
                    type="primary"
                    round
                    class="btn-default"
                    @click="dialogVisibleWork = true"
                    v-if="
                      canAdjustWorksheet() &&
                        mData.workSealedStatus === false
                    "
                  >
                    Nhập dữ liệu <i class="icon-Pen ml-2" style="font-size: 14px !important"></i>
                  </el-button>
                  <el-popover
                    class="ml-2"
                    width="210"
                    popper-class="poper_cus"
                    placement="bottom-end"
                    trigger="click"
                  >
                    <div>
                      <b-row>
                        <b-col md="6">
                          <el-button
                            type="primary"
                            round
                            plain
                            class="btn-default"
                            @click="openExportDialog('Synthetic')"
                          >
                            Tổng hợp
                          </el-button>
                        </b-col>
                        <b-col md="6">
                          <el-button
                            type="primary"
                            round
                            plain
                            class="btn-default"
                            @click="openExportDialog('Detail')"
                          >
                            Chi tiết
                          </el-button>
                        </b-col>
                      </b-row>
                    </div>
                    <el-button
                      slot="reference"
                      type="primary"
                      round
                      class="btn-default"
                      v-if="mData.dataDefault.listFeature.includes('FT805')"
                    >
                      Xuất bảng công <i class="el-icon-arrow-right"></i>
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="main-body-search mb-3 mt-3">
              <b-row>
                <b-col lg="10" md="10" sm="9" cols="12">
                  <el-form-item label="Điều kiện">
                    <el-input
                      v-model="mData.tableRules.dataSearch.value.condition"
                      placeholder="Nhập Mã nhân viên, Họ và tên, Số điện thoại, Số CMND/CCCD"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col lg="2" md="2" sm="3" cols="12">
                  <div class="text-center">
                    <el-button
                      class="btn-default w-100"
                      round
                      native-type="submit"
                      type="primary"
                      @click="fn_search()"
                    >
                      Tìm kiếm
                    </el-button>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="auto">
                  <el-form-item label="Công ty">
                    <el-select
                      v-model="search_company_id"
                      @change="fn_handleWorksheetCompanyFilterChange"
                      filterable
                      clearable
                      class="salary_period"
                      placeholder="Tất cả công ty"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listCompany"
                        :key="item.id"
                        :label="item.name && item.name.name_vi ? item.name.name_vi : item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="auto">
                  <el-form-item label="Phòng ban">
                    <el-select
                      v-model="search_department_ids"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                      class="salary_period"
                      placeholder="Tất cả phòng ban"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listDepartment"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="auto">
                  <el-form-item label="Chi nhánh">
                    <el-select
                      v-model="search_branch_ids"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                      class="salary_period"
                      placeholder="Tất cả chi nhánh"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listBranch"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="auto">
                  <el-form-item label="Trạng thái" label-width="125px" style="white-space: nowrap">
                    <el-select
                      v-model="search_employee_status"
                      clearable
                      class="salary_period"
                      placeholder="Tất cả trạng thái"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listTrangThaiLamViec"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </div>
            <div class="main-body-view__type mb-3">
              <div class="mb-2">
                <b-row>
                  <b-col xl="4" lg="4" md="4" sm="5" cols="7" class="d-flex">
                    <el-form-item label="Chọn thời gian">
                      <el-select
                        class="margin-right-35"
                        v-model="mData.timeView"
                        @change="changeTimeView"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listTimeView"
                          :key="item.code"
                          :label="item.label"
                          :value="item.code"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-date-picker
                      v-if="mData.timeView == 'day'"
                      class="ml-1"
                      v-model="mData.day"
                      type="date"
                      placeholder=""
                      format="dd/MM/yyyy"
                      @change="changeDate"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </b-col>
                  <b-col sm="2" v-if="mData.timeView !== 'day'">
                    <div class="mt-3">
                      <el-checkbox v-model="typeViewNumber"
                        >Dạng số</el-checkbox
                      >
                    </div>
                  </b-col>
                  <div class="d-flex mr-3" v-if="mData.timeView == 'day' && canAdjustWorksheet()">
                    <el-button
                      type="success"
                      round
                      plain
                      class="btn-default"
                      :disabled="notHaveWork || mData.workSealedStatus === true"
                      v-if="
                        mData.timeView == 'day' &&
                          canAdjustWorksheet()
                      "
                      @click="fn_submitWorkDay('approve')"
                    >
                      Duyệt
                    </el-button>
                    <el-button
                      size="medium"
                      plain
                      class="hai"
                      :disabled="notHaveWork || mData.workSealedStatus === true"
                      v-if="mData.timeView == 'day' && canAdjustWorksheet()"
                      @click="fn_submitWorkDay('un_approve')"
                      round
                    >
                      Từ chối
                    </el-button>
                  </div>
                </b-row>
              </div>
              <div class="d-flex justify-content-end">
                <div class="d-flex note-circle text-left">
                  <div md="2" class="d-flex at-center mr-3">
                    <div class="circle-note full-work"></div>
                    <p class="mb-0">Công đủ</p>
                  </div>
                  <div md="2" class="d-flex at-center mr-3">
                    <div class="circle-note work-have-problem"></div>
                    <p class="mb-0">Công có vấn đề</p>
                  </div>
                  <div md="2" class="d-flex at-center mr-3">
                    <div class="circle-note go-to-work-on-holiday"></div>
                    <p class="mb-0">Làm ngày lễ</p>
                  </div>
                  <div md="2" class="d-flex at-center mr-3">
                    <div class="circle-note holiday"></div>
                    <p class="mb-0">Nghỉ lễ</p>
                  </div>
                  <div md="2" class="d-flex at-center">
                    <div class="circle-note no-need-checkin"></div>
                    <p class="mb-0">Không cần chấm công</p>
                  </div>
                  <div md="2" class="d-flex at-center ml-3">
                    <div class="circle-note edited-work"></div>
                    <p class="mb-0">Ngày công chỉnh sửa</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="main-body-table mt-2">
              <el-table
                v-if="mData.timeView == 'month'"
                :data="tableData"
                border
                style="width: 100%"
                max-height="490"
                :lazy="true"
              >
                <el-table-column
                  fixed
                  prop="full_name"
                  label="Họ và tên"
                  min-width="300"
                >
                  <template slot-scope="scope">
                    <p>
                      {{ scope.row.employee_no }} - {{ scope.row.full_name }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  prop="shift_code"
                  label="Ca làm việc"
                  width="110"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  fixed
                  prop="total_work"
                  label="Công"
                  width="70"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  width="70"
                  v-for="index in mData.totalDayInMonth"
                  :key="index - 1"
                  :label="getDayInYear(mData.year, mData.month, index)"
                  :class-name="
                    mData.dataDefault.listDayOff.includes((index < 10 ? '0' + index : index) +'/' +mData.month +'/' + mData.year) ?
                    'p-0' :
                    new Date(mData.month + ' ' + index + ', ' + mData.year).getDay() == '0' ||
                    new Date(mData.month + ' ' + index + ', ' + mData.year).getDay() == '6' ?
                    'p-0' :
                    'p-0'
                  "
                  align="center"
                >
                  <div slot-scope="scope">
                    <div
                      v-if="!typeViewNumber"
                      :class="fn_getWorksheetDisplayClass(
                        scope.row.days[index - 1],
                        scope.row.is_need_checkin,
                        (index < 10 ? '0' + index : index) + '/' + mData.month + '/' + mData.year
                      )"
                      @click="
                        mData.dataDefault.listFeature.includes('FT802')
                          ? fn_showDetail(scope.row, index - 1, '')
                          : ''
                      "
                    ></div>
                    <div v-if="typeViewNumber">
                      <span
                        class="bold worksheet-number-cell"
                        @click="
                          mData.dataDefault.listFeature.includes('FT802')
                            ? fn_showDetail(scope.row, index - 1, '')
                            : ''
                        "
                      >
                        {{
                          scope.row.days[index - 1] &&
                          scope.row.days[index - 1].work_value ? Math.round(scope.row.days[index - 1].work_value * 100) / 100 : ""
                        }}
                      </span>
                    </div>
                  </div>
                </el-table-column>
              </el-table>
              <!-- Table công theo ngày -->
              <div class="date-table">
                <el-table
                  v-if="mData.timeView == 'day' && showTableDate"
                  :data="tableDataByDate"
                  border
                  style="width: 100%"
                  max-height="auto"
                  :lazy="true"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    prop="full_name"
                    label="Họ và tên"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <p>
                        {{ scope.row.employee_no }} - {{ scope.row.full_name }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="shift_code"
                    label="Ca làm việc"
                    width="120"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    type="selection"
                    width="55"
                    :disabled="mData.workSealedStatus === true"
                    v-if="canAdjustWorksheet()"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="`${mData.date}`"
                    width="150"
                    align="center"
                    :name="new Date(mData.date).getDay()"
                    :class-name="
                      new Date(
                        MethodService.formatterMMDDYYYY(mData.date)
                      ).getDay() == '0' ||
                      new Date(
                        MethodService.formatterMMDDYYYY(mData.date)
                      ).getDay() == '6'
                        ? 'p-0'
                        : 'p-0'
                    "
                  >
                    <template slot-scope="scope">
                      <div class="hai">
                        <div
                          v-if="!typeViewNumber"
                          :class="fn_getWorksheetDisplayClass(
                            scope.row.day,
                            scope.row.is_need_checkin,
                            mData.date
                          )"
                          @click="
                            mData.dataDefault.listFeature.includes('FT802')
                              ? fn_showDetail(scope.row, '', mData.date)
                              : ''
                          "
                        ></div>
                        <div v-if="typeViewNumber">
                          <span
                            class="bold worksheet-number-cell"
                            @click="
                              mData.dataDefault.listFeature.includes('FT802')
                                ? fn_showDetail(scope.row, '', mData.date)
                                : ''
                            "
                          >
                            {{
                              scope.row.day && scope.row.day.work_value ? Math.round(scope.row.day.work_value * 100) / 100 : ""
                            }}
                          </span>
                        </div>
                        <div
                          class="check_icon"
                          v-if="
                            scope.row.day &&
                              scope.row.day.sealed &&
                              (scope.row.day.sealed === true ||
                                scope.row.day.sealed === false)
                          "
                        >
                          <el-tooltip
                            class="item"
                            effect="light"
                            :content="
                              scope.row.day.sealed === true
                                ? 'Đã duyệt'
                                : scope.row.day.sealed === false
                                ? 'Đã từ chối'
                                : ''
                            "
                            placement="top-start"
                          >
                            <el-image
                              v-if="scope.row.day.sealed === true"
                              style="width: 100%"
                              src="img/check_sign_icon.png"
                              fit="cover"
                            >
                            </el-image>
                          </el-tooltip>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="mt-3 d-flex justify-content-end" v-if="canAccessHistory()">
              <el-button
                type="primary"
                round
                class="btn-default"
                @click="fn_goToWorkChangeHistory"
              >
                Xem lịch sử chỉnh sửa bảng công
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- dialog import -->
    <el-dialog
      :visible.sync="dialogVisibleWork"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="true"
      :width="mData.fileUploadOption.File.fileList.length > 0 ?'85%' : '500px'"
      top="50px"
    >
      <div slot="title" class="d-flex1">
        <h5>Nhập dữ liệu công</h5>
      </div>
      <div class="div-upload">
        <el-upload
          class="upload-demo"
          :auto-upload="false"
          drag
          action
          :accept="mData.fileUploadOption.File.accept"
          :on-change="fn_updaloadWorkFile"
          :on-remove="fn_removeWorkFile"
          :file-list="mData.fileUploadOption.File.fileList"
          :multiple="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Kéo file vào hoặc <em>bấm để tải lên</em>
          </div>
        </el-upload>
      </div>
      <div class="d-flex al-center jc-end mb-2">
        <div class="mr-3">
          <p
            class="download__css"
            @click="downloadTemplateImport"
          >
            Tải template mẫu
          </p>
        </div>
        <el-button
          class="d-flex al-center"
          round
          @click="closeDialogVisibleWork"
        >
          Hủy
        </el-button>
        <el-button
          round
          class="btn-default d-flex al-center"
          @click="importWork"
          :disabled="mData.isInvalid"
        >
          Nhập dữ liệu
        </el-button>
      </div>
      <div v-if="mData.fileUploadOption.File.fileList.length > 0">
        <el-table
          :border="true"
          :data="mData.dataExcel"
          style="width: 100%"
          max-height="500"
        >
          <el-table-column prop="employeeNo" label="Mã nhân viên" width="150">
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="Thời điểm từ"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTimeUTC(scope.row.startDate) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="Thời điểm tới"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTimeUTC(scope.row.endDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="shiftCode" label="Mã ca" width="150" align="center">
          </el-table-column>
          <el-table-column prop="shiftName" label="Tên ca" min-width="70">
          </el-table-column>
          <el-table-column prop="reason" label="Lý do" min-width="180">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- dialog error import -->
    <el-dialog
      title="Lỗi khi nhập dữ liệu công"
      :visible.sync="dialogErrorVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="90%"
      top="50px"
    >
      <div>
        <div class="text-center mb-3">
          <h6>Có một số bản ghi đang bị lỗi. Vui lòng xem lại và nhập dữ liệu lại !</h6>
        </div>
        <el-table
          class="error-table"
          :border="true"
          :data="mData.dataDefault.listErrorImport"
          style="width: 100%"
          max-height="500"
        >
          <el-table-column prop="employeeNo" label="Mã nhân viên" width="150">
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="Thời điểm từ"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTimeUTC(scope.row.startDate) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="Thời điểm tới"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTimeUTC(scope.row.endDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="shiftCode" label="Mã ca" width="150">
          </el-table-column>
          <el-table-column prop="shiftName" label="Tên ca" width="150">
          </el-table-column>
          <el-table-column
            prop="reason"
            label="Lý do"
            min-width="150"
          ></el-table-column>
          <el-table-column prop="messages" label="Lỗi" min-width="190">
            <template slot-scope="scope">
              <ul class="list-error">
                <li v-for="item in scope.row.messages" :key="item">
                  {{ item }}
                </li>
              </ul>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- Dialog show detail date work -->
    <el-dialog
      :visible.sync="visibleDialogDetail"
      width="430px"
      top="180px"
      :before-close="closeDialogDetail"
    >
      <div slot="title">
        <div class="d-flex jc-space-between work_information">
          <div class="bold name">
            <p>{{ mData.dataDetailWork.employee_name }}</p>
          </div>
          <div class="bold date">
            <p>Ngày {{ mData.dataDetailWork.date }}</p>
          </div>
        </div>
      </div>
      <div>
        <b-row>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Mã chấm công: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.employee_no }}</span></b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Ca làm: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.shift_code }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Giờ vào: </span></b-col>
              <b-col md="6">
                <span class="bold" v-if="!mData.dataDetailWork.haveTimeKeepingOnline && mData.dataDetailWork.is_need_checkin">{{ mData.dataDetailWork.time_check_in }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Giờ ra: </span></b-col>
              <b-col md="6"><span class="bold" v-if="mData.dataDetailWork.is_need_checkin">{{ mData.dataDetailWork.time_check_out }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút đi sớm: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_early }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút đi muộn: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_late }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút về sớm: </span></b-col>
              <b-col md="6"><span class="bold">{{mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_home_early }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút về muộn: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_overtime }}</span></b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Công ghi nhận: </span></b-col>
              <b-col md="6" class="d-flex align-items-center">
                <template v-if="!editingWorkValue">
                  <span class="bold">
                    {{ Math.round((mData.dataDetailWork.work_value || 0) * 100) / 100 }}
                  </span>
                  <i
                    v-if="mData.dataDefault.listFeature.includes('FT1103')"
                    class="el-icon-edit ml-1"
                    style="cursor:pointer;color:var(--orange)"
                    @click="fn_startEditWorkValue"
                  ></i>
                </template>
                <template v-else>
                  <el-input-number
                    v-model="tempWorkValue"
                    :min="0"
                    :max="2.5"
                    :step="0.1"
                    :precision="2"
                    size="mini"
                    style="width:110px"
                  ></el-input-number>
                </template>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1" v-if="editingWorkValue">
            <b-row>
              <b-col md="6"><span>Lý do thay đổi <span class="required" style="color: #f56c6c !important">*</span>: </span></b-col>
              <b-col md="6">
                <el-input
                  class="work-reason-input"
                  :class="{ 'is-invalid': reasonChangeInvalid }"
                  v-model="tempWorkReason"
                  type="textarea"
                  :rows="2"
                  placeholder="Nhập lý do thay đổi công"
                  @input="reasonChangeInvalid = false"
                ></el-input>
                <div v-if="reasonChangeInvalid" class="work-reason-error">
                  Vui lòng nhập lý do thay đổi
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12">
            <b-row>
              <b-col md="6"><span>Số lần vào ra: </span></b-col>
              <b-col><span  class="bold">{{ mData.dataDetailWork.number_of_go_out }}</span></b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col md="12">
                <span class="request mb-1">Yêu cầu phép:</span>
                <ul v-if="loadEmployeeRequest">
                  <li
                    v-for="(item, index) in mData.dataDetailWork.requests"
                    :key="index"
                  >
                    <b-link ref="javascript:" @click="goToRequestDetail(item.id)">
                      {{ item.title ? item.title : "" }}
                    </b-link>
                      ({{
                        item.status == "WAITING_FOR_APPROVAL"
                          ? "Chờ duyệt"
                          : item.status == "REJECTED"
                          ? "Từ chối"
                          : item.status == "APPROVED"
                          ? "Đã duyệt"
                          : ""
                      }})
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="text-right">
            <span
              class="see_more"
              @click="
                fn_seeMore(
                  mData.dataDetailWork.employee_id,
                  mData.dataDetailWork.shift_id,
                  mData.dataDetailWork.date,
                  mData.dataDetailWork.requests
                )
              "
              v-if="showMoreRequest"
            >
              Xem thêm
            </span>
          </b-col>
          <b-col
            md="12"
            class="text-center mt-2"
            v-if="mData.workSealedStatus === false"
          >
            <b-row>
              <b-col md="6">
                <el-button
                  size="medium"
                  plain
                  type="success"
                  round
                  class="btn-default"
                  v-if="
                    mData.timeView == 'day' &&
                      canAdjustWorksheet()
                  "
                  @click="submit_oneDayWork('approve', mData.dataDetailWork)"
                >
                  Duyệt
                </el-button>
              </b-col>
              <b-col md="6">
                <el-button
                  size="medium"
                  plain
                  class=""
                  v-if="mData.timeView == 'day' && canAdjustWorksheet()"
                  @click="submit_oneDayWork('unApprove',mData.dataDetailWork)"
                  round
                >
                  Từ chối
                </el-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            md="12"
            class="text-right mt-2"
            v-if="mData.dataDefault.listFeature.includes('FT1004')"
          >
            <b-row>
              <b-col
                  v-if="
                    new Date(mData.dataDetailWork.date1).getTime() >=
                    new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                  md="6"
                  class="text-left"
                >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('day_off', mData.dataDetailWork.date, mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu xin nghỉ
                  <!-- <i class="fal fa-asterisk asterisk"></i> -->
                </b-link>
              </b-col>
              <b-col
                  v-if="
                    new Date(mData.dataDetailWork.date1).getTime() >=
                    new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                  md="6"
                  class="text-left"
                >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_late', mData.dataDetailWork.date, mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu đi muộn
                </b-link>
              </b-col>
              <b-col
                  v-if="
                    new Date(mData.dataDetailWork.date1).getTime() >=
                    new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                  md="6"
                  class="text-left"
                >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_home_early', mData.dataDetailWork.date, mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu về sớm
                </b-link>
              </b-col>
              <b-col
                  v-if="
                    new Date(mData.dataDetailWork.date1).getTime() >=
                    new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                  md="6"
                  class="text-left"
                >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_out', mData.dataDetailWork.date, mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu ra ngoài
                </b-link>
              </b-col>
              <b-col
                  v-if="
                    new Date(mData.dataDetailWork.date1).getTime() >=
                    new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 3 , 0, 0, 0).getTime()
                  "
                  md="6"
                  class="text-left"
                >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('business', mData.dataDetailWork.date, mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu công tác
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() <
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                md="6"
                class="text-left"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('work_addition',mData.dataDetailWork.date,mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu giải trình công
                  <!-- <i class="fal fa-asterisk asterisk"></i> -->
                </b-link>
              </b-col>
              <b-col
                md="6"
                class="text-left"
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() ==
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                "
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('online',mData.dataDetailWork.date,mData.dataDetailWork.employee_id)"
                >
                  Tạo yêu cầu chấm công online
                  <!-- <i class="fal fa-asterisk asterisk"></i> -->
                </b-link>
              </b-col>
              <!-- <p>{{new Date(mData.dataDetailWork.date1)}}</p>
              <p>{{new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0)}}</p> -->
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div v-if="editingWorkValue" slot="footer" class="text-center">
        <el-button round @click="editingWorkValue = false">Hủy</el-button>
        <el-button type="primary" round class="btn-default" @click="fn_saveWorkValue">Lưu</el-button>
      </div>
    </el-dialog>

    <Loading v-if="loading"/>

    <el-dialog
      title="Xuất bảng công"
      :visible.sync="syncDialogSelectTypeExport"
      width="560px"
    >
      <el-form label-width="120px" @submit.native.prevent>
        <el-form-item label="Kiểu xuất">
          <span class="bold">
            {{ exportConfig.type === "Synthetic" ? "Tổng hợp" : "Chi tiết" }}
          </span>
        </el-form-item>
        <el-form-item label="Kỳ tháng">
          <el-select
            v-model="exportConfig.salary_period_id"
            class="w-100"
          >
            <el-option
              v-for="item in mData.dataDefault.listSalaryPeriod"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Công ty">
          <el-select
            v-model="exportConfig.company_id"
            @change="fn_handleWorksheetExportCompanyChange"
            filterable
            clearable
            class="w-100"
            placeholder="Tất cả công ty"
          >
            <el-option
              v-for="item in mData.dataDefault.listCompany"
              :key="item.id"
              :label="item.name && item.name.name_vi ? item.name.name_vi : item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Trạng thái">
          <el-select
            v-model="exportConfig.employee_status"
            clearable
            class="w-100"
            placeholder="Tất cả trạng thái"
          >
            <el-option
              v-for="item in mData.dataDefault.listTrangThaiLamViec"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Chi nhánh">
          <el-select
            v-model="exportConfig.branch_ids"
            multiple
            filterable
            clearable
            collapse-tags
            class="w-100"
            placeholder="Tất cả chi nhánh"
          >
            <el-option
              v-for="item in exportBranchOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Phòng ban">
          <el-select
            v-model="exportConfig.department_ids"
            multiple
            filterable
            clearable
            collapse-tags
            class="w-100"
            placeholder="Tất cả phòng ban"
          >
            <el-option
              v-for="item in exportDepartmentOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button round @click="syncDialogSelectTypeExport = false">
          Hủy
        </el-button>
        <el-button
          type="primary"
          round
          class="btn-default"
          @click="confirmExportWorkSheet"
        >
          Xuất file
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as moment from "moment"
import _ from "lodash"
import MethodService from "../../../../service/MethodService"
import ExtensionService from "../../../../service/ExtensionService"
import DataService from "../../../../service/DataService"
import WorksheetModel from "./WorksheetModel"
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi"
import WorkApi from "../../../../moduleApi/WorkApi"
import WorkChangeHistoryApi from "../../../../moduleApi/WorkChangeHistoryApi"
import EmployeeApi from "../../../../moduleApi/EmployeeApi"
import ShiftApi from "../../../../moduleApi/ShiftApi"
import EmployeeShiftApi from "../../../../moduleApi/EmployeeShiftApi"
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi"
import DayOffApi from "../../../../moduleApi/DayOffApi"
import TimeKeepingLogApi from "../../../../moduleApi/TimeKeepingLogApi"
import BranchApi from "../../../../moduleApi/BranchApi"
import DepartmentApi from "../../../../moduleApi/DepartmentApi"
import CompanyApi from "../../../../moduleApi/CompanyApi"
import PositionApi from "../../../../moduleApi/PositionApi"
import ContractTypeApi from "../../../../moduleApi/ContractTypeApi"
import RankSalaryApi from "../../../../moduleApi/RankSalaryApi"
import CoefficientSalaryApi from "../../../../moduleApi/CoefficientSalaryApi"
import SubsidiesSalaryTypeApi from "../../../../moduleApi/SubsidiesSalaryTypeApi"
import Banner from "../../Dashboard/Banner.vue"
import FileSaver from "file-saver"
import Loading from "../../../../component/Loading"
import { Filter } from "mushroomjs"
export default {
  components: {
    Banner,
    Loading,
  },
  data() {
    return {
      loadEmployeeRequest: true,
      showMoreRequest: true,
      loading: false,
      data: 2,
      syncDialogSelectTypeExport: false,
      exportConfig: {
        type: "Detail",
        department_ids: [],
        branch_ids: [],
        salary_period_id: "",
        company_id: undefined,
        employee_status: "DANG_LAM_VIEC"
      },
      exportBranchOptions: [],
      exportDepartmentOptions: [],
      search_company_id: undefined,
      search_department_ids: [],
      search_branch_ids: [],
      search_employee_status: "DANG_LAM_VIEC",
      MethodService: MethodService,
      aExtension: ExtensionService,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() >=
              new Date(new Date().setDate(new Date().getDate() )) ||
            time.getTime() <
              new Date(new Date().getFullYear(), new Date().getMonth(), 1)
          );
        }
      },
      viewMenu: false,
      top: "0px",
      left: "0px",
      hashUrlDay: false,
      notHaveWork: true,
      showTableDate: false,
      tableData: [],
      tableDataByDate: [],
      check: false,
      dialogVisibleWork: false,
      dialogErrorVisible: false,
      visibleDialogDetail: false,
      editingWorkValue: false,
      tempWorkValue: null,
      tempWorkReason: "",
      reasonChangeInvalid: false,
      workChangeHistory: [],
      typeViewNumber: false,
      salaryPeriodName: "",
      salaryPeriod: undefined,
      mData: {
        arrWorkIds: [],
        workSealedStatus: false,
        month: 0,
        year: 0,
        day: undefined,
        date: "",
        isInvalid: true,
        totalDayInMonth: 0,
        currentDate: undefined,
        data: [],
        timeView: "month",
        moduleName: "Worksheet", //requied
        dialogFormImportNhanVien: false,
        tableRules: MethodService.copyObject(WorksheetModel.tableRules),
        dataDefault: {
          file: "",
          listSalaryPeriod: [],
          listBranchAll: [],
          listDepartmentAll: [],
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listErrorImport: [],
          listEmployee: [],
          listShift: [],
          listWork: [],
          listEmployeeShift: [],
          listEmployeeRequest: [],
          listEmployeeRequestDetail: [],
          listCompany: [],
          listBranch: [],
          listDepartment: [],
          listTrangThaiLamViec: DataService.listTrangThaiLamViec,
          listPosition: [],
          listContractType: [],
          listRankSalary: [],
          listCoefficientSalary: [],
          listSubsidiesSalary: [],
          listTimeKeepingLog: [],
          listCountEmployeeDayoff: [],
          listTimeView: [
            {
              code: "month",
              label: "Tháng"
            },
            {
              code: "day",
              label: "Ngày"
            }
          ],
          listFeature: MethodService.getListFeatures(),
          listDayOff: [],
          listDayOffRDOIds: [],
          listEditedWorkIds: new Set()
        },
        fileUploadOption: {
          File: {
            limit: 1,
            accept: ".xlsx, .xls",
            dialogVisible: false,
            fileList: []
          }
        },
        dataExcel: [],
        dataExcelHeader: [],
        dataExcelBody: [],
        dataDetailWork: {},
        firstDayInMonth: "",
        lastDayInMonth: "",
        companyInfo: {},
        listShiftIds: []
      },
      previousEmployeeIDRow: "",
      changeEmployeeId: "",
      shiftId: ""
    }
  },
  methods: {
    fn_getCompanyTreeScope(companies = [], rootCompanyId) {
      if (!rootCompanyId || !Array.isArray(companies) || companies.length === 0) {
        return [];
      }
      const companyMap = new Map();
      companies.forEach(item => {
        if (item && item.id) {
          companyMap.set(item.id, item);
        }
      });
      const scope = [];
      const visited = new Set();
      const stack = [rootCompanyId];
      while (stack.length > 0) {
        const currentId = stack.pop();
        if (!currentId || visited.has(currentId)) {
          continue;
        }
        visited.add(currentId);
        const currentCompany = companyMap.get(currentId);
        if (currentCompany) {
          scope.push(currentCompany);
        }
        companies.forEach(item => {
          if (item && item.parent_company_id === currentId && !visited.has(item.id)) {
            stack.push(item.id);
          }
        });
      }
      return scope;
    },
    fn_mergeCompanyScope(primaryCompanies = [], fallbackCompanies = []) {
      const companyMap = new Map();
      [...primaryCompanies, ...fallbackCompanies].forEach(item => {
        if (item && item.id && !companyMap.has(item.id)) {
          companyMap.set(item.id, item);
        }
      });
      return Array.from(companyMap.values());
    },
    fn_getCompanyScopeIds() {
      const scopeCompanies = this.mData.dataDefault.listCompany || [];
      if (this.search_company_id) {
        return [this.search_company_id];
      }
      if (scopeCompanies.length > 0) {
        return scopeCompanies.map(item => item.id).filter(Boolean);
      }
      const currentCompanyId = this.mData.companyInfo && this.mData.companyInfo.id
        ? this.mData.companyInfo.id
        : undefined;
      return currentCompanyId ? [currentCompanyId] : [];
    },
    fn_getWorksheetSelectedCompanyScopeIds(companyId) {
      const selectedCompanyId = companyId || (this.mData.companyInfo && this.mData.companyInfo.id);
      const scopeCompanies = this.fn_getCompanyTreeScope(
        this.mData.dataDefault.listCompany || [],
        selectedCompanyId
      );
      return scopeCompanies.map(item => item.id).filter(Boolean);
    },
    fn_getSelectedWorksheetSalaryPeriod() {
      const selectedSalaryPeriodId =
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id;
      return (this.mData.dataDefault.listSalaryPeriod || []).find(item => {
        if (!item) {
          return false;
        }
        if (item.id === selectedSalaryPeriodId) {
          return true;
        }
        return Array.isArray(item.salary_period_ids) &&
          item.salary_period_ids.includes(selectedSalaryPeriodId);
      }) || null;
    },
    fn_getWorksheetSalaryPeriodIds(companyIds = []) {
      const selectedSalaryPeriod = this.fn_getSelectedWorksheetSalaryPeriod();
      const fallbackSalaryPeriodId =
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id;
      if (!selectedSalaryPeriod) {
        return fallbackSalaryPeriodId ? [fallbackSalaryPeriodId] : [];
      }

      const allSalaryPeriodIds = Array.isArray(selectedSalaryPeriod.salary_period_ids)
        ? selectedSalaryPeriod.salary_period_ids.filter(Boolean)
        : [];
      const salaryPeriodIdsByCompany = selectedSalaryPeriod.salary_period_ids_by_company || {};
      const scopedSalaryPeriodIds = (companyIds || [])
        .map(companyId => salaryPeriodIdsByCompany[companyId])
        .filter(Boolean);

      if (scopedSalaryPeriodIds.length > 0) {
        return [...new Set(scopedSalaryPeriodIds)];
      }
      if (allSalaryPeriodIds.length > 0) {
        return [...new Set(allSalaryPeriodIds)];
      }
      return selectedSalaryPeriod.id ? [selectedSalaryPeriod.id] : [];
    },
    fn_getWorksheetSalaryPeriodIdForCompany(companyId) {
      const selectedSalaryPeriod = this.fn_getSelectedWorksheetSalaryPeriod();
      const fallbackSalaryPeriodId =
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id;
      if (!selectedSalaryPeriod) {
        return fallbackSalaryPeriodId;
      }

      const salaryPeriodIdsByCompany = selectedSalaryPeriod.salary_period_ids_by_company || {};
      const currentCompanyId = this.mData.companyInfo && this.mData.companyInfo.id
        ? this.mData.companyInfo.id
        : undefined;

      return salaryPeriodIdsByCompany[companyId] ||
        salaryPeriodIdsByCompany[currentCompanyId] ||
        selectedSalaryPeriod.id ||
        fallbackSalaryPeriodId;
    },
    async fn_applyWorksheetCompanyDependentOptions() {
      const query = { limit: 1000000, feature_code: "FT2305" };
      if (this.search_company_id) {
         query.filters = `company_id=${this.search_company_id}`
      }
      try {
        const [branchRes, departmentRes] = await Promise.all([
          BranchApi.list(query, true),
          DepartmentApi.list(query, true)
        ]);
        const branchOptions = branchRes.result || [];
        const departmentOptions = departmentRes.result || [];
        const branchOptionIds = branchOptions.map(item => item.id);
        const departmentOptionIds = departmentOptions.map(item => item.id);
        this.mData.dataDefault.listBranch = branchOptions;
        this.mData.dataDefault.listDepartment = departmentOptions;
        this.search_branch_ids = (this.search_branch_ids || []).filter(id => branchOptionIds.includes(id));
        this.search_department_ids = (this.search_department_ids || []).filter(id => departmentOptionIds.includes(id));
      } catch (error) {
        console.error(error);
      }
    },
    async fn_loadWorksheetShiftOptions(companyId, shiftIds = []) {
      const body = {
        limit: shiftIds.length > 0 ? shiftIds.length : 100000
      };
      if (companyId) {
        body.company_id = companyId;
      }
      if (shiftIds.length > 0) {
        body.shift_ids = shiftIds;
      }
      const shiftApiRes = await ShiftApi.GetWorksheetShiftOptions(body);
      this.mData.dataDefault.listShift = shiftApiRes.result || [];
      return this.mData.dataDefault.listShift;
    },
    async fn_handleWorksheetCompanyFilterChange() {
      await this.fn_applyWorksheetCompanyDependentOptions();
      await this.fn_loadWorksheetShiftOptions(this.search_company_id);
    },
    async fn_applyWorksheetExportCompanyDependentOptions() {
      const query = { limit: 1000000, feature_code: "FT2305" };
      if (this.exportConfig.company_id) {
        query.filters = `company_id=${this.exportConfig.company_id}`
      }
      try {
        const [branchRes, departmentRes] = await Promise.all([
          BranchApi.list(query, true),
          DepartmentApi.list(query, true)
        ]);
        const branchOptions = branchRes.result || [];
        const departmentOptions = departmentRes.result || [];
        const branchOptionIds = branchOptions.map(item => item.id);
        const departmentOptionIds = departmentOptions.map(item => item.id);
        this.exportBranchOptions = branchOptions;
        this.exportDepartmentOptions = departmentOptions;
        this.exportConfig.branch_ids = (this.exportConfig.branch_ids || []).filter(id => branchOptionIds.includes(id));
        this.exportConfig.department_ids = (this.exportConfig.department_ids || []).filter(id => departmentOptionIds.includes(id));
      } catch (error) {
        console.error(error);
      }
    },
    fn_handleWorksheetExportCompanyChange() {
      this.fn_applyWorksheetExportCompanyDependentOptions();
    },
    async fn_getMergedEmployeeRequestDetails(companyScopeIds, dataFilterEmployeeRequest) {
      const scopeIds = (companyScopeIds || []).filter(Boolean);
      if (!scopeIds.length) {
        return { result: [] };
      }
      if (scopeIds.length === 1) {
        return EmployeeRequestApi.getListEmployeeRequestDetail(
          {
            ...dataFilterEmployeeRequest,
            cid: scopeIds[0],
          },
          true
        );
      }

      const responses = await Promise.all(
        scopeIds.map((companyId) =>
          EmployeeRequestApi.getListEmployeeRequestDetail(
            {
              ...dataFilterEmployeeRequest,
              cid: companyId,
            },
            true
          ).catch(() => ({ result: [] }))
        )
      );

      const resultMap = new Map();
      responses.forEach((response) => {
        (response && response.result ? response.result : []).forEach((item) => {
          if (item && item.id && !resultMap.has(item.id)) {
            resultMap.set(item.id, item);
          }
        });
      });

      return { result: Array.from(resultMap.values()) };
    },
    async fn_getMergedTimeKeepingLogs(companyScopeIds, dataFilterWorkDetail) {
      const scopeIds = (companyScopeIds || []).filter(Boolean);
      if (!scopeIds.length) {
        return { result: [] };
      }
      if (scopeIds.length === 1) {
        return TimeKeepingLogApi.getTimeKeepingLogByCompany({
          ...dataFilterWorkDetail,
          cid: scopeIds[0],
        });
      }

      const responses = await Promise.all(
        scopeIds.map((companyId) =>
          TimeKeepingLogApi.getTimeKeepingLogByCompany({
            ...dataFilterWorkDetail,
            cid: companyId,
          }).catch(() => ({ result: [] }))
        )
      );

      const resultMap = new Map();
      responses.forEach((response) => {
        (response && response.result ? response.result : []).forEach((item) => {
          if (item && item.id && !resultMap.has(item.id)) {
            resultMap.set(item.id, item);
          }
        });
      });

      return { result: Array.from(resultMap.values()) };
    },
    canAdjustWorksheet() {
      const features = this.mData.dataDefault.listFeature || [];
      return features.includes("FT806") || features.includes("FT804");
    },
    fn_isEditedWork(workId) {
      return !!(workId && this.mData.dataDefault.listEditedWorkIds && this.mData.dataDefault.listEditedWorkIds.has(workId));
    },
    fn_getWorksheetDisplayClass(work, isNeedCheckin, date) {
      if (!work || !work.work_value) return "circle-visible";
      if (this.fn_isEditedWork(work.id)) {
        return "circle-note-work-table edited-work";
      }

      const isDayOff = this.mData.dataDefault.listDayOff.includes(date);
      const hasCheckin =
        work.checkin_time && typeof work.checkin_time.hour === "number";
      if (isDayOff && hasCheckin) {
        return "circle-note-work-table go-to-work-on-holiday";
      }
      if (isDayOff) {
        return "circle-note-work-table holiday";
      }

      const expectedValue = this.fn_getWorkExpectedValue(work);
      const workValue = Math.round((work.work_value || 0) * 100) / 100;
      if (workValue >= expectedValue) {
        return "circle-note-work-table full-work";
      }
      if (workValue > 0 && workValue < expectedValue) {
        return "circle-note-work-table work-have-problem";
      }
      if (isNeedCheckin === false) {
        return "circle-note-work-table no-need-checkin";
      }

      return "circle-visible";
    },
    fn_getWorkExpectedValue(work) {
      if (!work || !work.number_of_day) return 1;
      return Math.round(work.number_of_day * 100) / 100;
    },
    fn_getWorkMinuteOfDay(value) {
      if (!value || value.hour == undefined || value.minute == undefined) {
        return null;
      }
      return value.hour * 60 + value.minute;
    },
    fn_getWorkScore(work) {
      if (!work) return Number.NEGATIVE_INFINITY;
      const expectedValue = this.fn_getWorkExpectedValue(work);
      const workValue = Math.round((work.work_value || 0) * 100) / 100;
      const fullWorkBonus = workValue >= expectedValue ? 100000 : 0;
      const latePenalty = Math.round((work.minute_go_late || 0) * 10);
      const earlyPenalty = Math.round((work.minute_go_home_early || 0) * 10);
      const checkinMinute = this.fn_getWorkMinuteOfDay(work.checkin_time);
      const checkoutMinute = this.fn_getWorkMinuteOfDay(work.checkout_time);
      const hasCheckinBonus = checkinMinute != null ? 1000 : 0;
      const hasCheckoutBonus = checkoutMinute != null ? 1000 : 0;
      const updatedAt = work.updated_at ? new Date(work.updated_at).getTime() : 0;
      const createdAt = work.created_at ? new Date(work.created_at).getTime() : 0;

      return (
        fullWorkBonus +
        Math.round(workValue * 1000) +
        hasCheckinBonus +
        hasCheckoutBonus -
        latePenalty -
        earlyPenalty +
        updatedAt / 1e10 +
        createdAt / 1e10
      );
    },
    fn_toTimestamp(value, fallback) {
      if (!value) return fallback;
      const timestamp = new Date(value).getTime();
      return Number.isNaN(timestamp) ? fallback : timestamp;
    },
    fn_isEmployeeShiftActive(employeeShift, currentTimestamp) {
      if (!employeeShift) return false;
      if (!employeeShift.end_time) return true;
      return this.fn_toTimestamp(employeeShift.end_time, Number.NEGATIVE_INFINITY) > currentTimestamp;
    },
    fn_compareEmployeeShiftPriority(firstItem, secondItem, currentTimestamp) {
      const firstActive = this.fn_isEmployeeShiftActive(firstItem, currentTimestamp);
      const secondActive = this.fn_isEmployeeShiftActive(secondItem, currentTimestamp);

      if (firstActive !== secondActive) {
        return firstActive ? -1 : 1;
      }

      const firstUpdatedAt = this.fn_toTimestamp(firstItem && firstItem.updated_at, 0);
      const secondUpdatedAt = this.fn_toTimestamp(secondItem && secondItem.updated_at, 0);
      if (firstUpdatedAt !== secondUpdatedAt) {
        return secondUpdatedAt - firstUpdatedAt;
      }

      const firstCreatedAt = this.fn_toTimestamp(firstItem && firstItem.created_at, 0);
      const secondCreatedAt = this.fn_toTimestamp(secondItem && secondItem.created_at, 0);
      if (firstCreatedAt !== secondCreatedAt) {
        return secondCreatedAt - firstCreatedAt;
      }

      const firstNeedCheckin = firstItem && firstItem.is_need_checkin === true;
      const secondNeedCheckin = secondItem && secondItem.is_need_checkin === true;
      if (firstNeedCheckin !== secondNeedCheckin) {
        return firstNeedCheckin ? -1 : 1;
      }

      return 0;
    },
    fn_normalizeEmployeeShifts(employeeShifts, options = {}) {
      if (!Array.isArray(employeeShifts) || employeeShifts.length === 0) {
        return [];
      }

      const currentTimestamp =
        typeof options.currentTimestamp === "number"
          ? options.currentTimestamp
          : Date.now();
      const logger =
        options.logger === false
          ? null
          : typeof options.logger === "function"
          ? options.logger
          : console.warn;
      const groupedEmployeeShifts = employeeShifts.reduce((result, item) => {
        const groupKey = [item && item.employee_id || "", item && item.shift_id || ""].join("|");
        if (!result[groupKey]) {
          result[groupKey] = [];
        }
        result[groupKey].push(item);
        return result;
      }, {});

      return Object.values(groupedEmployeeShifts).map((group) => {
        const normalizedGroup = group.slice().sort((firstItem, secondItem) =>
          this.fn_compareEmployeeShiftPriority(firstItem, secondItem, currentTimestamp)
        );

        if (normalizedGroup.length > 1 && logger) {
          const selectedItem = normalizedGroup[0] || {};
          logger("[Worksheet] Duplicate employee_shift detected", {
            employee_id: selectedItem.employee_id,
            shift_id: selectedItem.shift_id,
            records: group,
          });
        }

        return normalizedGroup[0];
      });
    },
    fn_getEmployeeRequest(request) {
      if (!request) return null;
      if (request.type && request.status) return request;
      const requestId = request.request_id || request.id;
      return (this.mData.dataDefault.listEmployeeRequest || []).find(function(item) {
        return item.id === requestId;
      }) || request;
    },
    fn_isApprovedRequestType(request, type) {
      const employeeRequest = this.fn_getEmployeeRequest(request);
      return !!(
        employeeRequest &&
        employeeRequest.type === type &&
        employeeRequest.status === "APPROVED"
      );
    },
    fn_getMinutesOfDay(time) {
      if (
        !time ||
        typeof time.hour !== "number" ||
        typeof time.minute !== "number"
      ) {
        return null;
      }

      return time.hour * 60 + time.minute;
    },
    fn_getShiftHalfBoundaries(shiftId, date) {
      const shift = (this.mData.dataDefault.listShift || []).find(function(item) {
        return item.id === shiftId;
      });
      const dayString = this.fn_getShiftDayString(date);
      const workDay =
        shift &&
        Array.isArray(shift.work_days) &&
        shift.work_days.length > 0
          ? shift.work_days.find(function(item) {
            return item && item.name === dayString;
          }) || shift.work_days[0]
          : null;
      const periods =
        workDay && Array.isArray(workDay.period_time) ? workDay.period_time : [];
      const morningPeriod = periods.length > 0 ? periods[0] : null;
      const afternoonPeriod = periods.length > 1 ? periods[1] : null;

      return {
        morningEndMinutes: this.fn_getMinutesOfDay(
          morningPeriod && morningPeriod.end_time
        ),
        afternoonStartMinutes: this.fn_getMinutesOfDay(
          afternoonPeriod && afternoonPeriod.start_time
        ),
        hasAfternoonPeriod: !!afternoonPeriod
      };
    },
    fn_getShiftDayString(date) {
      if (!date) return undefined;
      const month = Number(this.mData.month) - 1;
      const year = Number(this.mData.year);
      const day = Number(date);
      const dateValue = new Date(year, month, day);
      const dayOfWeek = dateValue.getDay();
      return dayOfWeek === 0 ? "8" : (dayOfWeek + 1).toString();
    },
    fn_getApprovedDayOffCoverage(employeeId, shiftId, date) {
      const targetDate = Number(date);
      const boundaries = this.fn_getShiftHalfBoundaries(shiftId, date);
      const coverage = {
        coversMorning: false,
        coversAfternoon: false
      };

      (this.mData.dataDefault.listEmployeeRequestDetail || []).forEach(
        (request) => {
          if (
            !request ||
            request.employee_id !== employeeId ||
            request.type !== "DAY_OFF" ||
            request.status !== "APPROVED" ||
            !Array.isArray(request.day_off)
          ) {
            return;
          }

          request.day_off.forEach((item) => {
            const itemDate = new Date(item.day);
            const isMatched =
              item &&
              item.shift_id === shiftId &&
              Array.isArray(item.odd_shifts) &&
              itemDate.getDate() === targetDate &&
              itemDate.getMonth() + 1 === Number(this.mData.month) &&
              itemDate.getFullYear() === Number(this.mData.year);

            if (!isMatched) {
              return;
            }

            if (item.odd_shifts.length === 1) {
              if (item.odd_shifts[0] === 1) {
                coverage.coversMorning = true;
                coverage.coversAfternoon = boundaries.hasAfternoonPeriod;
              }
              return;
            }

            if (item.odd_shifts[0] === 1) {
              coverage.coversMorning = true;
            }
            if (boundaries.hasAfternoonPeriod && item.odd_shifts[1] === 1) {
              coverage.coversAfternoon = true;
            }
          });
        }
      );

      return coverage;
    },
    fn_shouldIgnoreAttendanceForDayOff(work, employeeId, shiftId, minuteField) {
      const coverage = this.fn_getApprovedDayOffCoverage(
        employeeId,
        shiftId,
        work && work.date
      );
      if (!coverage.coversMorning && !coverage.coversAfternoon) {
        return false;
      }

      if (coverage.coversMorning && coverage.coversAfternoon) {
        return true;
      }

      const boundaries = this.fn_getShiftHalfBoundaries(shiftId, work && work.date);
      if (minuteField === "minute_go_late") {
        const checkinMinutes = this.fn_getMinutesOfDay(work && work.checkin_time);
        if (checkinMinutes === null) {
          return false;
        }

        if (coverage.coversMorning && !coverage.coversAfternoon) {
          return (
            typeof boundaries.afternoonStartMinutes === "number" &&
            checkinMinutes < boundaries.afternoonStartMinutes
          );
        }

        if (!coverage.coversMorning && coverage.coversAfternoon) {
          return (
            typeof boundaries.afternoonStartMinutes === "number" &&
            checkinMinutes >= boundaries.afternoonStartMinutes
          );
        }
      }

      if (minuteField === "minute_go_home_early") {
        const checkoutMinutes = this.fn_getMinutesOfDay(work && work.checkout_time);
        if (checkoutMinutes === null) {
          return false;
        }

        if (coverage.coversMorning && !coverage.coversAfternoon) {
          return (
            typeof boundaries.afternoonStartMinutes === "number" &&
            checkoutMinutes < boundaries.afternoonStartMinutes
          );
        }

        if (!coverage.coversMorning && coverage.coversAfternoon) {
          return (
            typeof boundaries.morningEndMinutes === "number" &&
            checkoutMinutes > boundaries.morningEndMinutes
          );
        }
      }

      return false;
    },
    fn_normalizeExportUnpaidHalfDay(work, isNeedCheckin, employeeId, shiftId) {
      const result = {
        unpaidLeave: 0,
        lateMinutes: work && work.minute_go_late ? Math.round(work.minute_go_late * 100) / 100 : 0,
        earlyMinutes: work && work.minute_go_home_early ? Math.round(work.minute_go_home_early * 100) / 100 : 0
      };

      if (!work || work.haveWork === false || !isNeedCheckin) return result;
      if (
        this.fn_hasApprovedTimeKeepingOnlineRequest(work) ||
        this.fn_hasApprovedTimeKeepingOnlineDetail(employeeId, shiftId, work.date) ||
        this.fn_hasApprovedWorkExplanationRequest(work) ||
        this.fn_hasApprovedWorkExplanationDetail(employeeId, shiftId, work.date)
      ) {
        return result;
      }

      const dayOffCoverage = this.fn_getApprovedDayOffCoverage(employeeId, shiftId, work.date);
      if (dayOffCoverage.coversMorning && dayOffCoverage.coversAfternoon) return result;
      if (
        this.fn_hasApprovedDayOffRequest(work) &&
        !dayOffCoverage.coversMorning &&
        !dayOffCoverage.coversAfternoon
      ) {
        return result;
      }

      const checkinMinutes = this.fn_getMinutesOfDay(work.checkin_time);
      const checkoutMinutes = this.fn_getMinutesOfDay(work.checkout_time);
      const boundaries = this.fn_getShiftHalfBoundaries(shiftId, work.date);
      if (
        !boundaries.hasAfternoonPeriod ||
        typeof boundaries.morningEndMinutes !== "number" ||
        typeof boundaries.afternoonStartMinutes !== "number"
      ) {
        return result;
      }

      const morningMinutes = Math.max(0, boundaries.morningEndMinutes - this.fn_getShiftStartMinutes(shiftId, work.date));
      const afternoonMinutes = Math.max(0, this.fn_getShiftEndMinutes(shiftId, work.date) - boundaries.afternoonStartMinutes);

      if (
        !dayOffCoverage.coversMorning &&
        morningMinutes > 0 &&
        checkinMinutes !== null &&
        checkinMinutes >= boundaries.afternoonStartMinutes &&
        result.lateMinutes >= morningMinutes
      ) {
        result.unpaidLeave += 0.5;
        result.lateMinutes = Math.max(0, Math.round((result.lateMinutes - morningMinutes) * 100) / 100);
      }

      if (
        !dayOffCoverage.coversAfternoon &&
        afternoonMinutes > 0 &&
        checkoutMinutes !== null &&
        checkoutMinutes <= boundaries.afternoonStartMinutes &&
        result.earlyMinutes >= afternoonMinutes
      ) {
        result.unpaidLeave += 0.5;
        result.earlyMinutes = Math.max(0, Math.round((result.earlyMinutes - afternoonMinutes) * 100) / 100);
      }

      result.unpaidLeave = Math.min(result.unpaidLeave, 1);
      return result;
    },
    fn_getShiftStartMinutes(shiftId, date) {
      const shift = (this.mData.dataDefault.listShift || []).find(item => item.id === shiftId);
      const dayString = this.fn_getShiftDayString(date);
      const workDay = shift && Array.isArray(shift.work_days)
        ? shift.work_days.find(item => item && item.name === dayString) || shift.work_days[0]
        : null;
      const period = workDay && Array.isArray(workDay.period_time) ? workDay.period_time[0] : null;
      return this.fn_getMinutesOfDay(period && period.start_time) || 0;
    },
    fn_getShiftEndMinutes(shiftId, date) {
      const shift = (this.mData.dataDefault.listShift || []).find(item => item.id === shiftId);
      const dayString = this.fn_getShiftDayString(date);
      const workDay = shift && Array.isArray(shift.work_days)
        ? shift.work_days.find(item => item && item.name === dayString) || shift.work_days[0]
        : null;
      const periods = workDay && Array.isArray(workDay.period_time) ? workDay.period_time : [];
      const period = periods.length ? periods[periods.length - 1] : null;
      return this.fn_getMinutesOfDay(period && period.end_time) || 0;
    },
    fn_hasApprovedTimeKeepingOnlineDetail(employeeId, shiftId, date) {
      const targetDate = Number(date);
      return (this.mData.dataDefault.listEmployeeRequestDetail || []).some(
        (request) => {
          if (
            !request ||
            request.employee_id !== employeeId ||
            request.type !== "TIME_KEEPING_ONLINE" ||
            request.status !== "APPROVED" ||
            request.shift_work_online !== shiftId ||
            !request.online_date
          ) {
            return false;
          }

          const onlineDate = new Date(request.online_date);
          return (
            onlineDate.getDate() === targetDate &&
            onlineDate.getMonth() + 1 === Number(this.mData.month) &&
            onlineDate.getFullYear() === Number(this.mData.year)
          );
        }
      );
    },
    fn_hasApprovedWorkExplanationDetail(employeeId, shiftId, date) {
      const targetDate = Number(date);
      return (this.mData.dataDefault.listEmployeeRequestDetail || []).some(
        (request) => {
          if (
            !request ||
            request.employee_id !== employeeId ||
            request.type !== "WORK_EXPLANATION" ||
            request.status !== "APPROVED" ||
            request.shift_work_add !== shiftId
          ) {
            return false;
          }

          const startDate = request.start_date_work_add || request.explained_start_date || request.end_date_work_add || request.explained_end_date;
          const endDate = request.end_date_work_add || request.explained_end_date || startDate;
          if (!startDate || !endDate) return false;
          const fromDate = new Date(startDate);
          const toDate = new Date(endDate);
          const workDate = new Date(Number(this.mData.year), Number(this.mData.month) - 1, targetDate, 12);

          return fromDate <= workDate && workDate <= toDate;
        }
      );
    },
    fn_hasApprovedDayOffRequest(work) {
      return Array.isArray(work && work.employee_requests)
        ? work.employee_requests.some((request) =>
            this.fn_isApprovedRequestType(request, "DAY_OFF")
          )
        : false;
    },
    fn_hasApprovedWorkExplanationRequest(work) {
      return Array.isArray(work && work.employee_requests)
        ? work.employee_requests.some((request) =>
            this.fn_isApprovedRequestType(request, "WORK_EXPLANATION")
          )
        : false;
    },
    fn_hasApprovedTimeKeepingOnlineRequest(work) {
      return Array.isArray(work && work.employee_requests)
        ? work.employee_requests.some((request) =>
            this.fn_isApprovedRequestType(request, "TIME_KEEPING_ONLINE")
          )
        : false;
    },
    fn_shouldCountAttendanceError(work, isNeedCheckin, minuteField, employeeId, shiftId) {
      if (!work || work.haveWork === false) return false;

      const expectedValue = this.fn_getWorkExpectedValue(work);
      const workValue = Math.round((work.work_value || 0) * 100) / 100;
      if (workValue >= expectedValue) return false;
      if ((work[minuteField] || 0) <= 0) return false;
      if (this.fn_shouldIgnoreAttendanceForDayOff(work, employeeId, shiftId, minuteField)) {
        return false;
      }
      if (
        this.fn_hasApprovedWorkExplanationRequest(work) ||
        this.fn_hasApprovedWorkExplanationDetail(employeeId, shiftId, work.date)
      ) {
        return false;
      }
      if (
        isNeedCheckin &&
        (
          this.fn_hasApprovedTimeKeepingOnlineRequest(work) ||
          this.fn_hasApprovedTimeKeepingOnlineDetail(employeeId, shiftId, work.date)
        )
      ) {
        return false;
      }

      return true;
    },
    fn_shouldCountExportLateOccurrence(work, isNeedCheckin, minuteField, employeeId, shiftId) {
      if (!work || work.haveWork === false) return false;
      if ((work[minuteField] || 0) <= 0) return false;

      if (this.fn_shouldIgnoreAttendanceForDayOff(work, employeeId, shiftId, minuteField)) {
        return false;
      }
      if (
        this.fn_hasApprovedWorkExplanationRequest(work) ||
        this.fn_hasApprovedWorkExplanationDetail(employeeId, shiftId, work.date)
      ) {
        return false;
      }
      if (
        isNeedCheckin &&
        (
          this.fn_hasApprovedTimeKeepingOnlineRequest(work) ||
          this.fn_hasApprovedTimeKeepingOnlineDetail(employeeId, shiftId, work.date)
        )
      ) {
        return false;
      }

      return true;
    },
    fn_hasApprovedDayOffForLunch(work, employeeId, shiftId) {
      if (this.fn_hasApprovedDayOffRequest(work)) return true;
      const coverage = this.fn_getApprovedDayOffCoverage(
        employeeId,
        shiftId,
        work && work.date
      );
      return coverage.coversMorning || coverage.coversAfternoon;
    },
    fn_normalizeWorks(works) {
      if (!works || !works.length) return [];
      const grouped = _.groupBy(works, (item) =>
        [item.employee_id || "", item.shift_id || "", item.date || ""].join("|")
      );
      return Object.values(grouped).map((group) =>
        _.orderBy(
          group,
          [
            (item) => this.fn_getWorkScore(item),
            (item) => (item.updated_at ? new Date(item.updated_at).getTime() : 0),
            (item) => (item.created_at ? new Date(item.created_at).getTime() : 0),
          ],
          ["desc", "desc", "desc"]
        )[0]
      );
    },
    getDayInYear(year, month, date){
      let day = new Date(year, month - 1, date).getDay();
      if (day == 0) {
       return `CN (${date >= 10 ? date : '0'+date})`
      } else {
        return `T${day + 1} (${date >= 10 ? date : '0'+date})`
      }
    },
    downloadTemplateImport(){
      MethodService.exportTemplateImportWork(this.mData.dataDefault.listShift);
    },
    changeTimeView() {
      this.$router
        .replace({
          name: "Admin-Timekeeping-Worksheet",
          query: {
            filters: this.mData.tableRules.filters,
            salaryPeriodId: this.mData.tableRules.dataSearchSalaryPeriod.value
              .salary_period_id,
            viewType: this.mData.timeView
          }
        })
        .catch(err => {});
    },
    async fn_getDataWorkByEmployeeId() {
      this.$router
        .replace({
          name: "Admin-Timekeeping-Worksheet",
          query: {
            filters: this.mData.tableRules.filters,
            salaryPeriodId: this.mData.tableRules.dataSearchSalaryPeriod.value
              .salary_period_id,
            viewType: this.mData.timeView,
            date:
              this.mData.timeView == "day"
                ? this.fn_formatterDate(this.mData.day)
                : ""
          }
        })
        .catch(err => {});
      let employeeFilters = this.mData.tableRules.filters || "";
      if (this.search_employee_status) {
        employeeFilters += (employeeFilters ? "&" : "") + "status:in:" + this.search_employee_status;
      }
      const companyScopeIds = this.fn_getCompanyScopeIds();
      if (companyScopeIds.length > 0) {
        employeeFilters += (employeeFilters ? "&" : "") + "company_id:in:" + companyScopeIds.join(",");
      }
      let dataFilter = {
        filters: employeeFilters,
        limit: 100000,
        sort: "administrative_info.name.first_name"
      };
      await this.fn_loadWorksheetShiftOptions(this.search_company_id);
      const employeeApiRes = await EmployeeApi.list(dataFilter, true);
      let filteredEmployees = employeeApiRes.result || [];
      if (this.search_department_ids.length) {
        filteredEmployees = filteredEmployees.filter(emp => {
          return (emp.job_info || []).some(j => this.search_department_ids.includes(j.department_id));
        });
      }
      if (this.search_branch_ids.length) {
        filteredEmployees = filteredEmployees.filter(emp => {
          return (emp.job_info || []).some(j => this.search_branch_ids.includes(j.branch_id));
        });
      }
      this.mData.dataDefault.listEmployee = filteredEmployees;
      let arrEmployeeIds = [];
      arrEmployeeIds = MethodService.findListItemDifferent(
        this.mData.dataDefault.listEmployee,
        "id"
      );
      let companyIds = [];
      if (this.search_company_id) {
        const selectedCompanies = this.fn_getCompanyTreeScope(
          this.mData.dataDefault.listCompany,
          this.search_company_id
        );
        companyIds = selectedCompanies.map(item => item.id).filter(Boolean);
      } else {
        companyIds = companyScopeIds;
      }
      const salaryPeriodIds = this.fn_getWorksheetSalaryPeriodIds(companyIds);
      let dataFilterWork = {
        limit: 9999999,
        cacheAge: 3000,
        filters:
          "salary_period_id:in:" +
          salaryPeriodIds.join(",") +
          "&employee_id:in:" +
          arrEmployeeIds.join(",")
      };
      let dataFilterEmployeeShift = {
        filters: Filter.and(
          Filter.in("employee_id", arrEmployeeIds),
          Filter.lte("start_time", this.mData.lastDayInMonth),
          Filter.or(
            Filter.isNull("end_time"),
            Filter.gte("end_time", this.mData.firstDayInMonth)
          )
        ).build(),
        sort: "employee_id",
        limit: 9999999
      };
      if (companyIds.length > 0) {
        dataFilterEmployeeShift.matches = [
          "company_id:in:" + companyIds.join(",")
        ];
      }
      this.mData.companyInfo = MethodService.getCompanyInfo();
      let dataFilterWorkDetail = {
        eid: null,
        cid: this.search_company_id || this.mData.companyInfo.id,
        start: new Date(this.mData.firstDayInMonth).toISOString(),
        end: new Date(this.mData.lastDayInMonth).toISOString(),
        skip: 0,
        limit: 9999999
      };
      let dataFilterEmployeeRequest = {
        sd: new Date(this.mData.firstDayInMonth).toISOString(),
        ed: new Date(this.mData.lastDayInMonth).toISOString(),
        cid: this.search_company_id || this.mData.companyInfo.id,
        eid: ""
      };

      const workApiReq = WorkApi.list(dataFilterWork, true);
      const employeeShiftApiReq = EmployeeShiftApi.list(
        dataFilterEmployeeShift, true
      );
      const employeeRequestDetailApiReq = this.fn_getMergedEmployeeRequestDetails(
        companyScopeIds,
        dataFilterEmployeeRequest
      );
      const timeKeepingLogEmployeeApiReq = this.fn_getMergedTimeKeepingLogs(
        companyScopeIds,
        dataFilterWorkDetail
      );

      const workApiRes = await workApiReq;
      const employeeShiftApiRes = await employeeShiftApiReq;
      const employeeRequestDetailApiRes = await employeeRequestDetailApiReq;
      const timeKeepingLogEmployeeApiRes = await timeKeepingLogEmployeeApiReq;

      // Load work change history to mark edited work days
      try {
        const fromDate = new Date(this.mData.firstDayInMonth);
        fromDate.setDate(fromDate.getDate() - 1);
        const lastDate = new Date(this.mData.lastDayInMonth);
        const changeHistoryRes = await WorkChangeHistoryApi.list({
          limit: 999999,
          target_work_date_from: fromDate.toISOString().slice(0, 10),
          target_work_date_to: lastDate.toISOString().slice(0, 10),
          company_id: this.mData.companyInfo.id
        });
        const editedIds = new Set();
        if (changeHistoryRes && changeHistoryRes.result) {
          changeHistoryRes.result.forEach(item => {
            if (item.work_id) editedIds.add(item.work_id);
          });
        }
        this.mData.dataDefault.listEditedWorkIds = editedIds;
      } catch (e) {
        this.mData.dataDefault.listEditedWorkIds = new Set();
      }

      this.mData.dataDefault.listTimeKeepingLog =
        timeKeepingLogEmployeeApiRes.result;
      if (workApiRes.result) {
        this.mData.dataDefault.listWork = this.fn_normalizeWorks(workApiRes.result);
      } else {
        this.mData.dataDefault.listWork = [];
      }
      this.mData.dataDefault.listEmployeeShift = employeeShiftApiRes.result;
      this.mData.dataDefault.listEmployeeRequestDetail =
        employeeRequestDetailApiRes.result;

      this.tableData = await this.fn_changeData(
        this.mData.dataDefault.listEmployee,
        this.mData.dataDefault.listWork,
        this.mData.dataDefault.listEmployeeShift
      );
      this.mData.listShiftIds = MethodService.findListItemDifferent(
        this.tableData,
        "shift_id"
      );

      this.tableDataByDate = await this.fn_changeDataTableByDate(
        this.tableData
      );
      let arrSortByEmployeeNo = this.tableData.sort((a,b) => {
        if (isNaN(parseInt(a.employee_no))) {
          if(a.employee_no < b.employee_no) { return -1; }
          if(a.employee_no > b.employee_no) { return 1; }
          return 0;
        } else {
          return a.employee_no - b.employee_no
        }
      })
      this.tableData = arrSortByEmployeeNo;
      this.showTableDate = true;
      this.check = true;

      setTimeout(() => {
        this.loading = false;
      }, 1000 * 1);
    },
    fn_changeData(arrEmployees, arrWork, arrEmployeeShift) {
      arrEmployees = Array.isArray(arrEmployees) ? arrEmployees : [];
      arrEmployeeShift = Array.isArray(arrEmployeeShift)
        ? MethodService.copyObject(arrEmployeeShift)
        : [];
      const salaryPeriod = this.fn_getSelectedWorksheetSalaryPeriod();
      if (!salaryPeriod) {
        this.mData.workSealedStatus = false;
        return [];
      }
      const monthOfPeriod = new Date(salaryPeriod.from_date).getMonth() + 1
      const yaerOfPeriod = new Date(salaryPeriod.from_date).getFullYear()
      this.mData.workSealedStatus = false;
      arrWork = this.fn_normalizeWorks(arrWork);
      arrEmployeeShift = this.fn_normalizeEmployeeShifts(arrEmployeeShift);
      if (arrWork.length == 0) {
        this.mData.workSealedStatus = false;
        for (let i = 1; i <= this.mData.totalDayInMonth; i++) {
          let data = {
            date: i,
            work_value: undefined,
            sealed: false
          };
          arrWork.push(data);
        }
      } else {
        let check = arrWork.find(e => {
          return e.sealed === false;
        });
        if (!check) {
          this.mData.workSealedStatus = true;
        }
      }
      let data = [];

      arrWork.forEach((item) => {
        let newItem = data.find((x) => x.employee_id === item.employee_id && x.shift_id === item.shift_id)
        if (newItem) {
          newItem.days.push(item)
        } else {
          data.push({
            employee_id: item.employee_id,
            shift_id: item.shift_id,
            shift_name: item.shift_name,
            days: [item]
          });
        }
      });
      data.forEach(item => {
        for (let i = 1; i <= this.mData.totalDayInMonth; i++) {
          let obj = {
            date: i,
            work: undefined,
            haveWork: false
          }
          let b = item.days.find(x => x.date == i)
          if (!b) {
            item.days.push(obj)
          }
        }
        item.days.sort((a, b) => {
          return a.date - b.date
        });
      })
      let totalShifts = {}
      arrEmployeeShift.forEach(e => {
        if (e.employee_id in totalShifts) {
          totalShifts[e.employee_id] += 1
        } else {
          totalShifts[e.employee_id] = 1
        }
      });
      arrEmployeeShift.forEach(item => {
        item.totalShift = totalShifts[item.employee_id]
        let dataByShift = data.find(x => x.employee_id === item.employee_id && x.shift_id === item.shift_id)
        let employee = arrEmployees.find(y => y.id === item.employee_id)
        let shift = this.mData.dataDefault.listShift.find(z => z.id === item.shift_id)

        if (dataByShift && dataByShift.days) {
          let arrCloneDays = MethodService.copyObject(dataByShift.days);
          const shiftStartTime = item.start_time ? new Date(item.start_time).getTime() : null;
          const shiftEndTime = item.end_time ? new Date(item.end_time).getTime() : null;
          const periodStartTime = new Date(salaryPeriod.from_date).getTime();
          const periodEndTime = new Date(salaryPeriod.before_to_date).getTime();
          const hasStartedAfterPeriod = shiftStartTime !== null && shiftStartTime > periodStartTime;
          const endsWithinPeriod = shiftEndTime !== null && shiftEndTime < periodEndTime;

          if (hasStartedAfterPeriod) {
            const startDay = new Date(item.start_time).getDate();
            arrCloneDays.forEach(day => {
              if (day.date < startDay) {
                day.work_value = undefined;
              }
            });
          }

          if (endsWithinPeriod) {
            const endDay = new Date(item.end_time).getDate();
            item.days = arrCloneDays.filter(day => day.date <= endDay);
          } else {
            item.days = arrCloneDays;
          }

          item.shift_name = dataByShift.shift_name;
        } else {
          item.days = []
          for (let i = 1; i <= this.mData.totalDayInMonth; i++) {
            let obj = {
              date: i,
              work: undefined,
              haveWork: false
            }
            item.days.push(obj)
          }
        }

        if (
          employee &&
          employee.administrative_info &&
          employee.administrative_info.name &&
          employee.administrative_info.name.full_name
        ) {
          if (employee.administrative_info.name.full_name) {
            item.full_name = employee.administrative_info.name.full_name;
          } else {
            item.full_name = " ";
          }
          if (employee.administrative_info.name.first_name) {
            item.first_name = employee.administrative_info.name.first_name;
          } else {
            item.first_name = employee.administrative_info.name.first_name;
          }
        } else {
          item.full_name = " ";
          item.first_name = " ";
        }
        if (employee && employee.card_no) {
          item.card_no = employee.card_no;
        } else {
          item.card_no = "";
        }
        if (employee && employee.employee_no) {
          item.employee_no = employee.employee_no;
        } else {
          item.employee_no = "";
        }
        if (shift && shift.code) {
          item.shift_code = shift.code;
        } else {
          item.shift_code = "";
        }
        if (shift && shift.name) {
          item.shift_name = shift.name;
        } else {
          item.shift_name = "";
        }
        let totalWork = 0;
        item.days.forEach(x => {
          totalWork += x && x.work_value ? x.work_value : 0
        });
        item.total_work = Math.round(totalWork * 100) / 100;
      });
      let employeeIdsHasShift = new Set(
        arrEmployeeShift
          .map(item => item.employee_id)
          .filter(item => !!item)
      );
      arrEmployees.forEach(employee => {
        if (!employee || !employee.id || employeeIdsHasShift.has(employee.id)) {
          return;
        }
        let days = [];
        for (let i = 1; i <= this.mData.totalDayInMonth; i++) {
          days.push({
            date: i,
            work: undefined,
            haveWork: false
          });
        }
        let full_name =
          employee &&
          employee.administrative_info &&
          employee.administrative_info.name &&
          employee.administrative_info.name.full_name
            ? employee.administrative_info.name.full_name
            : " ";
        let first_name =
          employee &&
          employee.administrative_info &&
          employee.administrative_info.name &&
          employee.administrative_info.name.first_name
            ? employee.administrative_info.name.first_name
            : " ";
        arrEmployeeShift.push({
          employee_id: employee.id,
          shift_id: "",
          shift_name: "",
          shift_code: "",
          full_name: full_name,
          first_name: first_name,
          card_no: employee.card_no || "",
          employee_no: employee.employee_no || "",
          totalShift: 0,
          total_work: 0,
          is_need_checkin: true,
          days: days
        });
      });
      return MethodService.sortByName(arrEmployeeShift, "employee_no")
    },
    goToRequest(type,date,eId) {
      if (type == "day_off") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-DayOffRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_late") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoLateRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_home_early") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoHomeEarlyRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "work_addition") {
        let dateFormat = MethodService.formatterMMDDYYYY(date);
        let day = new Date(dateFormat).getDate();
        let month = new Date(dateFormat).getMonth();
        let year = new Date(dateFormat).getFullYear();
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests",
            query:{
              day: day,
              month: month + 1,
              year: year,
              employee_id: eId,
              shift_id: this.shiftId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_out") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoOutRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "business") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoOnBussinessRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "online") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests",
            query: {
              employee_id: eId,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      }
    },
    async fn_submitWorkDay(type) {
      let data = {
        work_ids: this.mData.arrWorkIds
      };
      if (type == "approve") {
        this.$confirm(
          "Bạn có chắc chắn muốn chốt ngày công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            try {
              await WorkApi.ApproveWork(data);
              this.fn_getDataWorkByEmployeeId();
              window.toastr.success("Duyệt ngày công thành công!");
            } catch (error) {
              window.toastr.error("Duyệt ngày công thất bại!");
            }
          })
          .catch(() => {});
      } else if (type == "un_approve") {
        this.$confirm(
          "Bạn có chắc chắn muốn từ chối ngày công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            try {
              await WorkApi.UnapproveWork(data);
              this.fn_getDataWorkByEmployeeId();
              window.toastr.success("Từ chối ngày công thành công!");
            } catch (error) {
              window.toastr.error("Từ chối ngày công thất bại!");
            }
          })
          .catch(() => {});
      }
    },
    async submit_oneDayWork(type, dataOfday) {
      let company = MethodService.getCompanyInfo();
      let data = {
        work_value: this.mData.dataDetailWork.work_value
      };
      if (dataOfday.haveWork === false) {
        this.$confirm(
          "Bạn có chắc chắn muốn chốt công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            try {
              let dataCreate = MethodService.copyObject(WorksheetModel.dataCreateNewWork);
              let salary = this.fn_getSelectedWorksheetSalaryPeriod();
              dataCreate.employee_id = dataOfday.employee_id;
              dataCreate.company_id = company.id;
              dataCreate.company_name = company.name.name_vi;
              dataCreate.salary_period_id = this.fn_getWorksheetSalaryPeriodIdForCompany(company.id);
              dataCreate.salary_period_name = salary.name;
              dataCreate.shift_id = dataOfday.shift_id;
              dataCreate.shift_name = this.mData.dataDetailWork.shift_name;
              dataCreate.date = dataOfday.dateOfWork;
              dataCreate.work_value = parseFloat(this.mData.dataDetailWork.work_value);
              dataCreate.is_need_checkin = dataOfday.is_need_checkin;
              dataCreate.number_of_day = dataOfday.number_of_day;
              await WorkApi.create(dataCreate);
              this.fn_getDataWorkByEmployeeId();
              this.visibleDialogDetail = false;
              window.toastr.success("Duyệt công thành công");
            } catch (error) {
              if (error.code === 500) {
                window.toastr.error(`Ngày này nhân viên không đăng ký ca ${this.mData.dataDetailWork.shift_code} để làm việc`);
              } else {
                window.toastr.error("Duyệt công thất bại");
              }
            }
          })
          .catch(() => {});
      } else if (dataOfday.id && type == "approve") {
        this.$confirm(
          "Bạn có chắc chắn muốn chốt công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            data.id = dataOfday.id;
            data.sealed = true;
            data.work_value = parseFloat(this.mData.dataDetailWork.work_value);
            try {
              await WorkApi.update(data);
              window.toastr.success("Duyệt công thành công");
              this.fn_getDataWorkByEmployeeId();
              this.visibleDialogDetail = false;
            } catch (error) {
              window.toastr.error("Duyệt công thất bại");
            }
          })
          .catch(() => {});
      } else if (dataOfday.id && type == "unApprove") {
        this.$confirm(
          "Bạn có chắc chắn muốn từ chối công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            data.id = dataOfday.id;
            data.sealed = false;
            data.work_value = parseFloat(this.mData.dataDetailWork.work_value);
            try {
              delete data.work_value;
              await WorkApi.update(data);
              window.toastr.success("Từ chối công thành công");
              this.fn_getDataWorkByEmployeeId();
              this.visibleDialogDetail = false;
            } catch (error) {
              window.toastr.error("Từ chối công thất bại");
            }
          })
          .catch(() => {});
      }
    },
    handleSelectionChange(val) {
      this.mData.arrWorkIds = [];
      val.forEach(item => {
        if (item.day && item.day.id) {
          this.mData.arrWorkIds.push(item.day.id);
        }
      });
      if (this.mData.arrWorkIds.length > 0) {
        this.notHaveWork = false;
      } else {
        this.notHaveWork = true;
      }
    },
    fn_showDetail(row, date, day) {
      this.shiftId = row.shift_id;
      let arrRequestIds =
        date || date === 0
          ? row.days && row.days[date] && row.days[date].employee_requests
            ? row.days[date].employee_requests
            : []
          : row.day && row.day.employee_requests
          ? row.day.employee_requests
          : [];
      if ((date || date === 0) && !day) {
        this.mData.dataDetailWork = {
          id: row.days[date] && row.days[date].id ? row.days[date].id : "",
          data: row,
          is_need_checkin: row.is_need_checkin,
          employee_id: row.employee_id,
          employee_no: row.employee_no,
          employee_name: row.full_name,
          haveWork:
            row.days[date] && row.days[date].haveWork != undefined ? false : true,
          dateOfWork: row.days[date] && row.days[date].date ? row.days[date].date : date + 1,
          date:
            row.days[date] && row.days[date].date
              ? row.days[date].date < 10
                ? "0" +
                  row.days[date].date +
                  "/" +
                  this.mData.month +
                  "/" +
                  this.mData.year
                : row.days[date].date +
                  "/" +
                  this.mData.month +
                  "/" +
                  this.mData.year
              : (date + 1 < 10 ? "0" + (date + 1) : date + 1) +
                "/" +
                this.mData.month +
                "/" +
                this.mData.year,
          card_no: row.card_no,
          shift_id: row.shift_id,
          shift_code: row.shift_code,
          shift_name: row.shift_name,
          time_check_in: row.days[date]
            ? (row.days[date].checkin_time &&
              row.days[date].checkin_time.hour != undefined
                ? row.days[date].checkin_time.hour < 10
                  ? "0" + row.days[date].checkin_time.hour
                  : row.days[date].checkin_time.hour
                : "") +
              (row.days[date].checkin_time ? ":" : "") +
              (row.days[date].checkin_time &&
              row.days[date].checkin_time.minute != undefined
                ? row.days[date].checkin_time.minute < 10
                  ? "0" + row.days[date].checkin_time.minute
                  : row.days[date].checkin_time.minute
                : "")
            : "",
          time_check_out: row.days[date]
            ? (row.days[date].checkout_time &&
              row.days[date].checkout_time.hour != undefined
                ? row.days[date].checkout_time.hour < 10
                  ? "0" + row.days[date].checkout_time.hour
                  : row.days[date].checkout_time.hour
                : "") +
              (row.days[date].checkout_time ? ":" : "") +
              (row.days[date].checkout_time &&
              row.days[date].checkout_time.minute != undefined
                ? row.days[date].checkout_time.minute < 10
                  ? "0" + row.days[date].checkout_time.minute
                  : row.days[date].checkout_time.minute
                : "")
            : "",
          minute_go_early:
            row.days[date] && row.days[date].minute_go_early
              ? Math.round(row.days[date].minute_go_early * 100) / 100
              : "0",
          minute_go_late:
            row.days[date] && row.days[date].minute_go_late
              ? Math.round(row.days[date].minute_go_late * 100) / 100
              : "0",
          work_value:
            row.days[date] && row.days[date].work_value
              ? row.days[date].work_value
              : "0",
          number_of_go_out:
            row.days[date] && row.days[date].number_of_go_out
              ? Math.round(row.days[date].number_of_go_out * 100) / 100
              : "0",
          minute_go_home_early:
            row.days[date] && row.days[date].minute_go_home_early
              ? Math.round(row.days[date].minute_go_home_early * 100) / 100
              : "0",
          minute_overtime:
            row.days[date] && row.days[date].minute_overtime
              ? Math.round(row.days[date].minute_overtime * 100) / 100
              : "0",
          isSealed: row.days[date] ? row.days[date].sealed : undefined,
          number_of_day: row.days[date] && row.days[date].number_of_day ? row.days[date].number_of_day : 0,
          requests: [],
          date1:
            row.days[date] && row.days[date].date
              ? row.days[date].date < 10
                ? this.mData.month +
                  "/" +
                  "0" +
                  row.days[date].date +
                  "/" +
                  this.mData.year
                : this.mData.month +
                  "/" +
                  row.days[date].date +
                  "/" +
                  this.mData.year
              : this.mData.month +
                "/" +
                (date + 1 < 10 ? "0" + (date + 1) : date + 1) +
                "/" +
                this.mData.year
        };
      } else if (day) {
        if (row.end_time && new Date(row.end_time).getTime() < new Date(MethodService.formatterMMDDYYYY(day)).getTime()) {
          window.toastr.warning("Ca làm việc đã hết hiệu lực!")
          return;
        }
        if (row.start_time && new Date(row.start_time).getTime() > new Date(MethodService.formatterMMDDYYYY(day)).getTime()) {
          window.toastr.warning("Ca làm việc chưa có hiệu lực!")
          return;
        }
        this.mData.dataDetailWork = {
          id: row.day && row.day.id ? row.day.id : "",
          data: row,
          is_need_checkin: row.is_need_checkin,
          employee_id: row.employee_id,
          employee_no: row.employee_no,
          employee_name: row.full_name,
          haveWork: row.day && row.day.haveWork != undefined ? false : true,
          dateOfWork: row.day.date,
          date: row.day
            ? row.day.date < 10
              ? "0" +
                row.day.date +
                "/" +
                this.mData.month +
                "/" +
                this.mData.year
              : row.day.date + "/" + this.mData.month + "/" + this.mData.year
            : day,
          card_no: row.card_no,
          shift_id: row.shift_id,
          shift_code: row.shift_code,
          shift_name: row.shift_name,
          time_check_in: row.day
            ? (row.day.checkin_time && row.day.checkin_time.hour != undefined
                ? row.day.checkin_time.hour < 10
                  ? "0" + row.day.checkin_time.hour
                  : row.day.checkin_time.hour
                : "") +
              (row.day.checkin_time ? ":" : "") +
              (row.day.checkin_time && row.day.checkin_time.minute != undefined
                ? row.day.checkin_time.minute < 10
                  ? "0" + row.day.checkin_time.minute
                  : row.day.checkin_time.minute
                : "")
            : "",
          time_check_out: row.day
            ? (row.day.checkout_time && row.day.checkout_time.hour != undefined
                ? row.day.checkout_time.hour < 10
                  ? "0" + row.day.checkout_time.hour
                  : row.day.checkout_time.hour
                : "") +
              (row.day.checkout_time ? ":" : "") +
              (row.day.checkout_time &&
              row.day.checkout_time.minute != undefined
                ? row.day.checkout_time.minute < 10
                  ? "0" + row.day.checkout_time.minute
                  : row.day.checkout_time.minute
                : "")
            : "",
          minute_go_early:
            row.day && row.day.minute_go_early
              ? Math.round(row.day.minute_go_early * 100) / 100
              : "0",
          minute_go_late:
            row.day && row.day.minute_go_late
              ? Math.round(row.day.minute_go_late * 100) / 100
              : "0",
          work_value:
            row.day && row.day.work_value
              ? Math.round(row.day.work_value * 100) / 100
              : 0,
          number_of_go_out:
            row.day && row.day.number_of_go_out
              ? Math.round(row.day.number_of_go_out * 100) / 100
              : "0",
          minute_go_home_early:
            row.day && row.day.minute_go_home_early
              ? Math.round(row.day.minute_go_home_early * 100) / 100
              : "0",
          minute_overtime:
            row.day && row.day.minute_overtime
              ? Math.round(row.day.minute_overtime * 100) / 100
              : "0",
          requests: [],
          isSealed: row.day.sealed,
          number_of_day: row.day.number_of_day,
          date1: MethodService.formatterMMDDYYYY(day)
        };
      }
      arrRequestIds.forEach((item, index) => {
        let emRequest = this.mData.dataDefault.listEmployeeRequest.find(
          e => e.id === item.request_id
        );
        if (emRequest) {
          let obj = {
            id: emRequest.id,
            title: emRequest.title ? emRequest.title : emRequest.content,
            status: emRequest.status,
            type: emRequest.type
          };

          this.mData.dataDetailWork.requests.push(obj);
        }
      })
      let checkHaveTimeKeepingOnline = this.mData.dataDetailWork.requests.find(e =>{
        return e.type == "TIME_KEEPING_ONLINE" && e.status == "APPROVED"
      })
      if (checkHaveTimeKeepingOnline != undefined) {
        this.mData.dataDetailWork.haveTimeKeepingOnline = true;
      } else {
        this.mData.dataDetailWork.haveTimeKeepingOnline = false;
      }
      this.visibleDialogDetail = true;
      this.workChangeHistory = [];
      if (this.mData.dataDetailWork.id) {
        WorkChangeHistoryApi.list({ filters: `work_id=${this.mData.dataDetailWork.id}` })
          .then(res => { this.workChangeHistory = res.result || []; })
          .catch(() => {});
      }
    },
    goToRequestDetail(id) {
      let routeData = this.$router.resolve({
        name: "Admin-ManageRequests-CheckRequest",
        params: { id: id },
        query: {
          from: "WorkSheet"
        }
      });
      window.open(routeData.href, '_blank');
      // this.$router
      // .push({
      //   name: "Admin-ManageRequests-CheckRequest",
      //   params: { id: id }
      // })
    },
    async changeDate() {
      this.$router
        .replace({
          name: "Admin-Timekeeping-Worksheet",
          query: {
            filters: this.mData.tableRules.filters,
            salaryPeriodId: this.mData.tableRules.dataSearchSalaryPeriod.value
              .salary_period_id,
            viewType: this.mData.timeView,
            date: this.fn_formatterDate(this.mData.day)
          }
        })
        .catch(err => {});
      this.showTableDate = false;
      this.tableDataByDate = await this.fn_changeDataTableByDate(
        this.tableData
      );
      this.showTableDate = true;
    },
    async fn_initDataDefault() {
      let salaryPeriodApiRes;
      let shiftApiRes;
      let employeeRequestApiRes;
      let dayOffApiRes;
      let branchApiRes, departmentApiRes, companyScopeRes, companyApiRes;
      [salaryPeriodApiRes, shiftApiRes, employeeRequestApiRes, dayOffApiRes, branchApiRes, departmentApiRes, companyScopeRes, companyApiRes] = await Promise.all([
        SalaryPeriodApi.GetWorksheetSalaryPeriodOptions({ limit: 100 }),
        ShiftApi.GetWorksheetShiftOptions({ limit: 100000 }),
        EmployeeRequestApi.list({ limit: 10000 }, true),
        DayOffApi.list({
          limit: 100,
          filters: "disabled!=true"
        }, true),
        BranchApi.list({ limit: 1000000 }, true),
        DepartmentApi.list({ limit: 1000000 }, true),
        CompanyApi.GetCompanyFilterOptions({}, true),
        CompanyApi.list({ limit: 1000000 }, true)
      ]);

      const companyInfo = MethodService.getCompanyInfo();
      const scopedCompaniesFromFilter =
        companyScopeRes.result && Array.isArray(companyScopeRes.result.companies) && companyScopeRes.result.companies.length > 0
          ? companyScopeRes.result.companies
          : (companyInfo && companyInfo.id ? [companyInfo] : []);
      const scopedCompaniesFromTree = this.fn_getCompanyTreeScope(
        companyApiRes.result || [],
        companyInfo && companyInfo.id ? companyInfo.id : undefined
      );
      const companyScopeCompanies = this.fn_mergeCompanyScope(
        scopedCompaniesFromFilter,
        scopedCompaniesFromTree
      );
      const companyScopeIds = companyScopeCompanies.map(item => item.id).filter(Boolean);

      this.mData.dataDefault.listSalaryPeriod = salaryPeriodApiRes.result || [];
      this.mData.dataDefault.listShift = shiftApiRes.result || [];
      this.mData.dataDefault.listEmployeeRequest = employeeRequestApiRes.result;
      this.mData.dataDefault.listCompany = companyScopeCompanies;
      this.mData.dataDefault.listBranchAll = (branchApiRes.result || []).filter(item => {
        return companyScopeIds.length === 0 || companyScopeIds.includes(item.company_id);
      });
      this.mData.dataDefault.listDepartmentAll = (departmentApiRes.result || []).filter(item => {
        return companyScopeIds.length === 0 || companyScopeIds.includes(item.company_id);
      });
      this.fn_applyWorksheetCompanyDependentOptions();
      this.fn_applyWorksheetExportCompanyDependentOptions();
      dayOffApiRes.result.forEach(item => {
        this.mData.dataDefault.listDayOff.push(
          this.fn_formatterDate(item.off_date)
        );
      });

      this.mData.dataDefault.listSalaryPeriod.sort(function(a, b) {
        return (
          new Date(b.from_date).getTime() - new Date(a.from_date).getTime()
        );
      });
      let arrCunrentSalaryPeriod = this.mData.dataDefault.listSalaryPeriod.filter(
        item => {
          return (
            new Date(item.from_date).getTime() <= new Date().getTime() &&
            new Date().getTime() < new Date(item.before_to_date).getTime()
          );
        }
      );

      if (arrCunrentSalaryPeriod.length > 0) {
        if (!this.$route.query.salaryPeriodId) {
          this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id = arrCunrentSalaryPeriod[0].id;
          this.getFirstAndLastDayInMonth(arrCunrentSalaryPeriod[0]);
        } else {
          let salaryPeriod = this.mData.dataDefault.listSalaryPeriod.find(
            e => e.id === this.$route.query.salaryPeriodId
          );
          this.getFirstAndLastDayInMonth(salaryPeriod);
        }
      } else {
        this.loading = false;
      }
    },
    getFirstAndLastDayInMonth(salaryPeriod) {
      this.mData.firstDayInMonth = moment(
        new Date(salaryPeriod.from_date)
      )
        .utc()
        .format();
      this.mData.lastDayInMonth = moment(
        new Date(salaryPeriod.before_to_date).setDate(
          new Date(salaryPeriod.before_to_date).getDate() - 1
        )
      )
        .utc()
        .format();
      let datearray = this.fn_formatterDate(
        salaryPeriod.from_date
      ).split("/");
      this.mData.month = datearray[1];
      this.mData.year = datearray[2];
      this.mData.totalDayInMonth = this.daysInMonth(
        datearray[1],
        datearray[2]
      );
    },
    fn_changeDataTableByDate(data) {
      this.mData.date = this.fn_formatterDate(this.mData.day);
      let date = new Date(this.mData.day).getDate();
      data.forEach(item => {
        let day = item.days.find(x => x.date === date);
        item.day = day;
      });
      return data;
    },
    fn_search() {
      this.$refs["myFormSearch"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filtersWork = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearchSalaryPeriod)
          );
          await this.fn_getDataWorkByEmployeeId();
          // await this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_defaultSearch() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.filtersWork = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearchSalaryPeriod)
      );
      // await this.fn_getDataWorkByEmployeeId();
      this.fn_changeSalaryPeriod();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router
        .push({
          name: "Admin-Timekeeping-Worksheet",
          query: query
        })
        .catch(err => {});
    },
    async fn_changeSalaryPeriod() {
      try {
        this.loading = true
        const salaryPeriodApiReq = this.fn_getSelectedWorksheetSalaryPeriod()
          ? { result: this.fn_getSelectedWorksheetSalaryPeriod() }
          : await SalaryPeriodApi.findById(
              this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id
            );
        this.salaryPeriod = salaryPeriodApiReq.result;
        this.salaryPeriodName = salaryPeriodApiReq.result.name;
        this.mData.firstDayInMonth = salaryPeriodApiReq.result.from_date;
        this.mData.lastDayInMonth = salaryPeriodApiReq.result.before_to_date;
        if (
          new Date(salaryPeriodApiReq.result.from_date).getTime() <=
            new Date().getTime() &&
          new Date(salaryPeriodApiReq.result.before_to_date).getTime() >
            new Date().getTime()
        ) {
          let datearray = this.fn_formatterDate(
            salaryPeriodApiReq.result.from_date
          ).split("/");
          this.mData.month = datearray[1];
          this.mData.year = datearray[2];
          this.mData.totalDayInMonth = this.daysInMonth(
            datearray[1],
            datearray[2]
          );
          this.mData.day = new Date();
          this.pickerOptions = {
            disabledDate(time) {
              return (
                time.getTime() >=
                  new Date(new Date().setDate(new Date().getDate() )) ||
                time.getTime() <
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
              );
            }
          };
        } else {
          let datearray = this.fn_formatterDate(
            salaryPeriodApiReq.result.from_date
          ).split("/");
          this.mData.month = datearray[1];
          this.mData.year = datearray[2];
          this.mData.totalDayInMonth = this.daysInMonth(
            datearray[1],
            datearray[2]
          );
          if (this.hashUrlDay === false) {
            this.mData.day = new Date(this.mData.year, this.mData.month, 0);
          } else {
            this.mData.day = new Date(new Date(salaryPeriodApiReq.result.from_date).getFullYear(), new Date(salaryPeriodApiReq.result.from_date).getMonth(), new Date(salaryPeriodApiReq.result.from_date).getDate());
          }
          this.pickerOptions = {
            disabledDate(time) {
              return (
                time.getTime() <=
                  new Date(
                    new Date(salaryPeriodApiReq.result.from_date).getFullYear(),
                    new Date(salaryPeriodApiReq.result.from_date).getMonth(),
                    1
                  ) ||
                time.getTime() >=
                  new Date(
                    new Date(
                      salaryPeriodApiReq.result.before_to_date
                    ).getFullYear(),
                    new Date(salaryPeriodApiReq.result.before_to_date).getMonth(),
                    1
                  )
              );
            }
          };
        }
        this.fn_getDataWorkByEmployeeId();
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log("error",error);
      }
    },
    fn_formatterDate(cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    exportWorkSheet(type) {
      //nếu cần gọi API thì lấy từ trong xuất tổng hợp
      if (type == "Synthetic") {
        Promise.all([
          BranchApi.list({ limit: 1000000 }),
          DepartmentApi.list({ limit: 1000000 }),
          PositionApi.list({ limit: 1000000 }),
          ContractTypeApi.list({ limit: 1000000 }),
          RankSalaryApi.list({ limit: 1000000 }),
          CoefficientSalaryApi.list({limit: 1000000 }),
          SubsidiesSalaryTypeApi.list({ limit: 1000000 }),
          EmployeeRequestApi.GetCountRequestDayoffs({
            from_date: this.mData.firstDayInMonth,
            to_date: this.mData.lastDayInMonth
          })
        ]).then(async (res) => {
          this.mData.dataDefault.listBranch = res[0].result
          this.mData.dataDefault.listDepartment = res[1].result
          this.mData.dataDefault.listPosition = res[2].result
          this.mData.dataDefault.listContractType = res[3].result
          this.mData.dataDefault.listRankSalary = res[4].result
          this.mData.dataDefault.listCoefficientSalary = res[5].result
          this.mData.dataDefault.listSubsidiesSalary = res[6].result
          this.mData.dataDefault.listCountEmployeeDayoff = res[7].result
          let data = await this.fn_allWork(this.tableData, this.salaryPeriod)
          setTimeout(() => {
            MethodService.exportExcelWorkSynthetic(data, this.salaryPeriod)
          }, 1000 * 0.5)
        })
      } else if (type == "Detail") {
        MethodService.exportExcelWorkDetail(this.tableData, this.salaryPeriod)
      }
    },
    async openExportDialog(type) {
      await this.ensureExportResources(type);
      this.exportConfig.type = type;
      this.exportConfig.salary_period_id = this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id;
      this.exportConfig.company_id = this.search_company_id;
      this.exportConfig.employee_status = this.search_employee_status;
      this.exportConfig.department_ids = this.search_department_ids.slice();
      this.exportConfig.branch_ids = this.search_branch_ids.slice();
      this.fn_applyWorksheetExportCompanyDependentOptions();
      this.syncDialogSelectTypeExport = true;
    },
    async ensureExportResources(type) {
      const requests = [];
      if (!this.mData.dataDefault.listDepartment.length) {
        requests.push(
          DepartmentApi.list({ limit: 1000000 }).then((res) => {
            this.mData.dataDefault.listDepartment = res.result || [];
          })
        );
      }
      if (type === "Synthetic") {
        const loaders = [
          ["listBranch", BranchApi, { limit: 1000000 }],
          ["listPosition", PositionApi, { limit: 1000000 }],
          ["listContractType", ContractTypeApi, { limit: 1000000 }],
          ["listRankSalary", RankSalaryApi, { limit: 1000000 }],
          ["listCoefficientSalary", CoefficientSalaryApi, { limit: 1000000 }],
          ["listSubsidiesSalary", SubsidiesSalaryTypeApi, { limit: 1000000 }]
        ];
        loaders.forEach(([key, api, payload]) => {
          if (!this.mData.dataDefault[key].length) {
            requests.push(
              api.list(payload).then((res) => {
                this.mData.dataDefault[key] = res.result || [];
              })
            );
          }
        });
        requests.push(
          EmployeeRequestApi.GetCountRequestDayoffs({
            from_date: this.mData.firstDayInMonth,
            to_date: this.mData.lastDayInMonth
          }).then((res) => {
            this.mData.dataDefault.listCountEmployeeDayoff = res.result || [];
          })
        );
      }
      if (requests.length) {
        await Promise.all(requests);
      }
    },
    getCurrentExportTime() {
      const salaryPeriod = this.salaryPeriod;
      if (!salaryPeriod) {
        return new Date().getTime();
      }
      const salaryPeriodEnd = new Date(salaryPeriod.before_to_date).getTime();
      return Math.min(Date.now(), salaryPeriodEnd);
    },
    getEmployeeDepartmentMeta(employeeId) {
      const employee = this.mData.dataDefault.listEmployee.find(
        (item) => item.id === employeeId
      );
      if (!employee) {
        return {
          departmentIds: [],
          departmentNames: []
        };
      }
      const currentTime = this.getCurrentExportTime();
      const validJobInfo = (employee.job_info || []).filter((item) => {
        if (item.end_date) {
          return (
            new Date(item.start_date).getTime() <= currentTime &&
            currentTime <= new Date(item.end_date).getTime()
          );
        }
        return new Date(item.start_date).getTime() <= currentTime;
      });
      const departmentIds = [
        ...new Set(
          validJobInfo
            .map((item) => item.department_id)
            .filter((item) => !!item)
        )
      ];
      const departmentNames = departmentIds
        .map((departmentId) => {
          const department = this.mData.dataDefault.listDepartment.find(
            (item) => item.id === departmentId
          );
          return department && department.name ? department.name : "";
        })
        .filter((item) => !!item);
      return {
        departmentIds,
        departmentNames
      };
    },
    getExportDepartmentNames(departmentIds) {
      if (!departmentIds || !departmentIds.length) {
        return [];
      }
      return this.mData.dataDefault.listDepartment
        .filter((item) => departmentIds.includes(item.id))
        .map((item) => item.name)
        .filter((item) => !!item);
    },
    filterTableDataByDepartments(data, departmentIds) {
      if (!departmentIds || !departmentIds.length) {
        return data;
      }
      return data.filter((item) => {
        const meta = this.getEmployeeDepartmentMeta(item.employee_id);
        return meta.departmentIds.some((departmentId) =>
          departmentIds.includes(departmentId)
        );
      });
    },
    getExportBranchNames(branchIds) {
      if (!branchIds || !branchIds.length) {
        return [];
      }
      return this.mData.dataDefault.listBranch
        .filter((item) => branchIds.includes(item.id))
        .map((item) => item.name)
        .filter((item) => !!item);
    },
    filterTableDataByBranches(data, branchIds) {
      if (!branchIds || !branchIds.length) {
        return data;
      }
      return data.filter((item) => {
        const employee = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id === item.employee_id
        );
        if (!employee) return false;
        return (employee.job_info || []).some((j) => branchIds.includes(j.branch_id));
      });
    },
    async confirmExportWorkSheet() {
      try {
        this.loading = true;
        const departmentIds = this.exportConfig.department_ids || [];
        const branchIds = this.exportConfig.branch_ids || [];
        const departmentNames = this.getExportDepartmentNames(departmentIds);
        const branchNames = this.getExportBranchNames(branchIds);

        // Get selected salary period
        const targetSalaryPeriod = this.fn_getSelectedWorksheetSalaryPeriod() || this.salaryPeriod;

        let filteredTableData = this.filterTableDataByDepartments(
          this.tableData,
          departmentIds
        );
        filteredTableData = this.filterTableDataByBranches(filteredTableData, branchIds);

        // Filter by company_id
        if (this.exportConfig.company_id) {
          filteredTableData = filteredTableData.filter(item => {
            const employee = this.mData.dataDefault.listEmployee.find(
              (emp) => emp.id === item.employee_id
            );
            return employee && employee.company_id === this.exportConfig.company_id;
          });
        }

        // Filter by employee_status
        if (this.exportConfig.employee_status) {
          filteredTableData = filteredTableData.filter(item => {
            const employee = this.mData.dataDefault.listEmployee.find(
              (emp) => emp.id === item.employee_id
            );
            return employee && employee.status === this.exportConfig.employee_status;
          });
        }

        // Get selected company name
        const selectedCompany = this.mData.dataDefault.listCompany.find(
          (c) => c.id === this.exportConfig.company_id
        );
        const companyName = selectedCompany && selectedCompany.name
          ? selectedCompany.name.name_vi || selectedCompany.name.abbreviation_name || selectedCompany.name
          : "";

        if (!filteredTableData.length) {
          window.toastr.warning("Không có dữ liệu bảng công phù hợp để xuất");
          this.loading = false;
          return;
        }

        this.syncDialogSelectTypeExport = false;
        if (this.exportConfig.type === "Synthetic") {
          const data = await this.fn_allWork(filteredTableData, targetSalaryPeriod);
          setTimeout(() => {
            MethodService.exportExcelWorkSynthetic(data, targetSalaryPeriod, {
              departmentNames,
              branchNames,
              companyName
            });
            this.loading = false;
          }, 500);
          return;
        }
        MethodService.exportExcelWorkDetail(filteredTableData, targetSalaryPeriod, {
          departmentNames,
          branchNames,
          companyName
        });
        this.loading = false;
      } catch (err) {
        console.error(err);
        window.toastr.error("Có lỗi xảy ra khi xuất file!");
        this.loading = false;
      }
    },
    //Xử lý dât bảng công để xuất chi tiết
    fn_changeDataExportExcel(data){
      let dataCheck = []
      data.forEach(item => {
        let findItemInArray = dataCheck.find(itemCheck => itemCheck.employee_id === item.employee_id)
        if (!findItemInArray) {
          dataCheck.push(item)
        } else {
          let arr = findItemInArray.days.concat(item.days)
          findItemInArray.days = arr.sort((a, b) => {
            return a.date - b.date
          })
        }
      })
      return dataCheck
    },
    //Lấy Data
    async fn_addStandardWorkForExport(data, salaryPeriod) {
      if (!Array.isArray(data) || !salaryPeriod) return data;
      const periodStart = new Date(salaryPeriod.from_date);
      const periodEnd = new Date(salaryPeriod.before_to_date);
      periodEnd.setMilliseconds(periodEnd.getMilliseconds() - 1);
      const standardWorkCache = {};
      const getTime = (value, fallback) => {
        if (!value) return fallback;
        const time = new Date(value).getTime();
        return Number.isNaN(time) ? fallback : time;
      };
      const calcStandardWork = async (employeeShift) => {
        const fromTime = Math.max(
          getTime(employeeShift.start_time, periodStart.getTime()),
          periodStart.getTime()
        );
        const toTime = Math.min(
          getTime(employeeShift.end_time, periodEnd.getTime()),
          periodEnd.getTime()
        );
        if (!employeeShift.shift_id || fromTime > toTime) return 0;
        const cacheKey = `${employeeShift.shift_id}|${fromTime}|${toTime}`;
        if (standardWorkCache[cacheKey] == null) {
          standardWorkCache[cacheKey] = ShiftApi.CalcStandardWork({
            shiftId: employeeShift.shift_id,
            employeeId: employeeShift.employee_id,
            formDate: new Date(fromTime),
            toDate: new Date(toTime)
          }).then((res) => {
            const workCount = res && res.result ? Number(res.result.workCount) : 0;
            return Number.isNaN(workCount) ? 0 : workCount;
          }).catch(() => 0);
        }
        return standardWorkCache[cacheKey];
      };

      await Promise.all(data.map(async (item) => {
        const employeeShifts = Array.isArray(item.employee_shifts)
          ? item.employee_shifts
          : [];
        const standardWorks = await Promise.all(employeeShifts.map(calcStandardWork));
        item.standard_work = standardWorks.reduce((total, value) => total + value, 0);
      }));
      return data;
    },
    async fn_allWork(data, salaryPeriod) {
      let dataAll = []
      let curentTime = new Date(salaryPeriod.before_to_date).getTime() < new Date().getTime() ? new Date(salaryPeriod.before_to_date).getTime() : new Date().getTime()
      data.forEach(item => {
        let obj = {
          employee_id: item.employee_id ? item.employee_id : "",
          employee_no: item.employee_no ? item.employee_no : "",
          employee_name: item.full_name ? item.full_name : "",
          arr_shift_code: item.shift_code ? [item.shift_code] : [""],
          arr_shift_name: item.shift_name ? [item.shift_name] : [""],
          arr_total_work: item.total_work ? [item.total_work] : [0],
          employee_shifts: item.shift_id ? [{
            employee_id: item.employee_id,
            shift_id: item.shift_id,
            start_time: item.start_time,
            end_time: item.end_time
          }] : [],
          list_request_day_off: [],
          list_request_online: [],
          list_request_bussiness: [],
          lunch_date_keys: [],
          lunch_excluded_date_keys: [],
          unpaid_leave_without_request: 0,
          go_late_count: 0,
          total_go_late_minutes: 0,
          go_home_early_count: 0,
          total_go_home_early_minutes: 0,
          day_off_count: 0,
        }
        item.days.forEach(day => {
          if (day.haveWork === false) return
          const lunchDateKey = `${item.employee_id}|${day.date}`;
          if (this.fn_hasApprovedDayOffForLunch(day, item.employee_id, item.shift_id)) {
            obj.lunch_excluded_date_keys.push(lunchDateKey)
          } else {
            obj.lunch_date_keys.push(lunchDateKey)
          }
          if (this.mData.dataDefault.listDayOff.includes((day.date < 10 ? '0' + day.date : day.date) +'/' + this.mData.month +'/' + this.mData.year)) {
            obj.day_off_count++
          }
          if (day.employee_requests && day.employee_requests.length > 0) {
            day.employee_requests.forEach(employeeRequest => {
              const request = this.fn_getEmployeeRequest(employeeRequest)
              if (request.type == "DAY_OFF") {
                obj['list_request_day_off'].push(request)
              }
              if (request.type == "TIME_KEEPING_ONLINE") {
                obj['list_request_online'].push(request)
              }
              if (request.type == "GO_ON_BUSSINESS") {
                obj['list_request_bussiness'].push(request)
              }
            })
          }
          const normalizedAttendance = this.fn_normalizeExportUnpaidHalfDay(day, item.is_need_checkin, item.employee_id, item.shift_id)
          obj.unpaid_leave_without_request += normalizedAttendance.unpaidLeave
          if (this.fn_shouldCountExportLateOccurrence(day, item.is_need_checkin, "minute_go_late", item.employee_id, item.shift_id) && normalizedAttendance.lateMinutes > 0) {
            obj.go_late_count++
            obj.total_go_late_minutes += normalizedAttendance.lateMinutes
          }
          if (this.fn_shouldCountAttendanceError(day, item.is_need_checkin, "minute_go_home_early", item.employee_id, item.shift_id) && normalizedAttendance.earlyMinutes > 0) {
            obj.go_home_early_count++
            obj.total_go_home_early_minutes += normalizedAttendance.earlyMinutes
          }
        })
        let employee = this.mData.dataDefault.listEmployee.find(e => {
          return e.id == item.employee_id
        })
        let validJobInfo = (employee.job_info || []).filter((e) => {
          if (e.end_date) {
            return (
              new Date(e.start_date).getTime() <= curentTime &&
              curentTime <= new Date(e.end_date).getTime()
            )
          } else {
            return new Date(e.start_date).getTime() <= curentTime
          }
        })
        let arrNameChucVu = []
        let arrNamePhongBan = []
        let arrNameChiNhanh = []
        let arrNameCongTy = []
        validJobInfo.forEach(e => {
          let chucVu = this.mData.dataDefault.listPosition.find((element) => {
            return element.id == e.position_id
          })
          let phongBan = this.mData.dataDefault.listDepartment.find((element) => {
            return element.id == e.department_id
          })
          let chiNhanh = this.mData.dataDefault.listBranch.find((element) => {
            return element.id == e.branch_id
          })
          let congTy = this.mData.dataDefault.listCompany.find((element) => {
            return employee && element.id == employee.company_id
          })
          if (chucVu && chucVu.name) arrNameChucVu.push(chucVu.name)
          if (phongBan && phongBan.name) arrNamePhongBan.push(phongBan.name)
          if (chiNhanh && chiNhanh.name) arrNameChiNhanh.push(chiNhanh.name)
          if (congTy && congTy.name) arrNameCongTy.push(congTy.name.name_vi || congTy.name.abbreviation_name || congTy.name)
        })
        obj["position_name"] = arrNameChucVu.length > 0 ? `- ${arrNameChucVu.join(`\r\n- `)}` : ""
        obj["department_name"] = arrNamePhongBan.length > 0 ? `- ${arrNamePhongBan.join(`\r\n- `)}` : ""
        obj["branch_name"] = arrNameChiNhanh.length > 0 ? `- ${arrNameChiNhanh.join(`\r\n- `)}` : ""
        obj["company_name"] = arrNameCongTy.length > 0 ? `- ${[...new Set(arrNameCongTy)].join(`\r\n- `)}` : ""
        obj["ot_time"] = 0
        dataAll.push(obj)
      })
      let arrDataFilter = []
      dataAll.forEach(item => {
        let checkDublicate = arrDataFilter.find(e => {
          return e.employee_no == item.employee_no
        })
        if (!checkDublicate) {
          arrDataFilter.push(item)
        } else {
          checkDublicate.arr_shift_code = checkDublicate.arr_shift_code.concat(item.arr_shift_code)
          checkDublicate.arr_shift_name = checkDublicate.arr_shift_name.concat(item.arr_shift_name)
          checkDublicate.arr_total_work = checkDublicate.arr_total_work.concat(item.arr_total_work)
          checkDublicate.employee_shifts = checkDublicate.employee_shifts.concat(item.employee_shifts)
          checkDublicate.list_request_day_off = checkDublicate.list_request_day_off.concat(item.list_request_day_off)
          checkDublicate.list_request_online = checkDublicate.list_request_online.concat(item.list_request_online)
          checkDublicate.list_request_bussiness = checkDublicate.list_request_bussiness.concat(item.list_request_bussiness)
          checkDublicate.lunch_date_keys = checkDublicate.lunch_date_keys.concat(item.lunch_date_keys)
          checkDublicate.lunch_excluded_date_keys = checkDublicate.lunch_excluded_date_keys.concat(item.lunch_excluded_date_keys)
          checkDublicate.unpaid_leave_without_request += item.unpaid_leave_without_request
          checkDublicate.go_late_count += item.go_late_count
          checkDublicate.total_go_late_minutes += item.total_go_late_minutes
          checkDublicate.go_home_early_count += item.go_home_early_count
          checkDublicate.total_go_home_early_minutes += item.total_go_home_early_minutes
          checkDublicate.ot_time += item.ot_time
          checkDublicate.day_off_count += item.day_off_count
        }
      })
      let resData = this.changeDatarequest(arrDataFilter)
      await this.fn_addStandardWorkForExport(resData, salaryPeriod)
      return resData
    },
    changeDatarequest(arrDataFilter) {
      arrDataFilter.forEach(e => {
        e.shift_code = e.arr_shift_code.length > 0 ? `- ${e.arr_shift_code.join(`\r\n- `)}` : ""
        e.shift_name = e.arr_shift_name.length > 0 ? `- ${e.arr_shift_name.join(`\r\n- `)}` : ""
        e.total_work = e.arr_total_work.length > 0 ? `${e.arr_total_work.join(`\r\n`)}` : ""
        e.total_salary_calculation = e.arr_total_work.reduce((a, b) => {
          return a + b
        }, 0)
        let resSummary = this.getCountTypeRequestDayOff(e.employee_id)
        e.paid_leave = resSummary.countLeaveWithPay
        e.unpaid_leave = resSummary.countLeaveWithoutPay + (e.unpaid_leave_without_request || 0)
        e.online = resSummary.countOnline
        e.bussiness = resSummary.countBussiness
        const excludedLunchDateKeys = new Set(e.lunch_excluded_date_keys || [])
        e.lunch_day_count = [...new Set(e.lunch_date_keys || [])].filter((dateKey) => {
          return !excludedLunchDateKeys.has(dateKey)
        }).length
        e.total_go_late_minutes = Math.round((e.total_go_late_minutes || 0) * 100) / 100
        e.total_go_home_early_minutes = Math.round((e.total_go_home_early_minutes || 0) * 100) / 100
      })
      return arrDataFilter
    },
    getCountTypeRequestDayOff(employeeId) {
      let countLeaveWithPay = 0
      let countLeaveWithoutPay = 0
      let countOnline = 0
      let countBussiness = 0
      let arrFilters = this.mData.dataDefault.listCountEmployeeDayoff.filter(e => e.employee_id == employeeId)
      arrFilters.forEach(e => {
        countLeaveWithPay += e.dayoff_has_salary_count
        countLeaveWithoutPay += e.dayoff_has_no_salary_count
        countOnline += e.online_request_count || 0
        countBussiness += e.bussiness_request_count || 0
      })
      return {
        countLeaveWithPay: countLeaveWithPay,
        countLeaveWithoutPay: countLeaveWithoutPay,
        countOnline: countOnline,
        countBussiness: countBussiness,
      }
    },
    //Lấy danh sách Sheet Chấm công
    fn_work(data) {
      let dataWork = [];
      let groupEmployee = [];
      let dataAfterFilter = [];
      this.mData.dataDefault.listEmployee.forEach(e => {
        data.forEach(x => {
          if (x.employee_no == e.employee_no) {
            dataAfterFilter.push(x);
          }
        });
      });
      dataAfterFilter.forEach(item => {
        if (item.employee_no) {
          let employee_no = item.employee_no;
          let time = item.time;
          let status = "";
          groupEmployee.push({
            employee_no: employee_no,
            time: time,
            status: status
          });
        }
      });
      groupEmployee.sort(function(a, b) {
        return new Date(a.time).getTime() - new Date(b.time).getTime();
      });
      let groupE = groupEmployee.reduce((r, a) => {
        r[a.employee_no] = [...(r[a.employee_no] || []), a];
        return r;
      }, {});
      for (const [key, value] of Object.entries(groupE)) {
        var groupT = _.groupBy(value, function(item) {
          return moment(item.time).startOf("day").format();
        });
        for (const [kT, vT] of Object.entries(groupT)) {
          if (vT && vT.length > 0) {
            for (let i = 0; i < vT.length; i++) {
              if (i % 2 == 0) {
                vT[i].status = "Vào";
              } else {
                vT[i].status = "Ra";
              }
              dataWork.push(vT[i]);
            }
          }
        }
      }
      return dataWork;
    },
    //Lấy danh sách Sheet Yêu cầu
    fn_employeeRequest(data) {
      let dataRequest = [];
      let dataAfterFilter = [];
      this.mData.dataDefault.listEmployee.forEach(e => {
        data.forEach(x => {
          if (x.employee_no == e.employee_no) {
            dataAfterFilter.push(x);
          }
        });
      });
      data.forEach(item => {
        let employee_no = item.employee_no;
        let type_request =
          item.type == "DAY_OFF"
            ? "Xin nghỉ"
            : item.type == "GO_LATE"
            ? "Đi muộn"
            : item.type == "COME_BACK_SOON"
            ? "Về sớm"
            : item.type == "WORK_EXPLANATION"
            ? "Giải trình công"
            : item.type == "GO_OUT"
            ? "Ra ngoài"
            : item.type == "GO_ON_BUSSINESS"
            ? "Công tác"
            : item.type == "TIME_KEEPING_ONLINE"
            ? "Chấm công Online"
            : "";
        let from_date =
          item.day_off && item.day_off[0].day
            ? item.day_off[0].day
            : item.extra_minute_go_late
            ? item.extra_minute_go_late
            : item.extra_minute_go_home
            ? item.extra_minute_go_home
            : item.end_date_work_add
            ? item.end_date_work_add
            : item.start_date_go_out
            ? item.start_date_go_out
            : item.online_date
            ? item.online_date
            : item.start_date_bussiness
            ? item.start_date_bussiness
            : "";
        let to_date = item.end_date_bussiness
          ? item.end_date_bussiness
          : item.end_date_go_out
          ? item.end_date_go_out
          : "";
        dataRequest.push({
          employee_no: employee_no,
          type_request: type_request,
          from_date: from_date,
          to_date: to_date
        });
      });
      return dataRequest;
    },
    //Lấy danh sách Sheet Ca làm việc
    fn_employeeShift(data) {
      let dataEmployeeShift = [];
      data.forEach(item => {
        let shiftCode = "";
        let employeeCode = "";

        let shift = this.mData.dataDefault.listShift.find(e => {
          return e.id == item.shift_id;
        });
        let employee = this.mData.dataDefault.listEmployee.find(e => {
          return e.id == item.employee_id;
        });
        if (shift && shift.code) {
          shiftCode = shift.code;
        } else {
          shiftCode = "";
        }
        if (employee && employee.employee_no) {
          employeeCode = employee.employee_no;
        } else {
          employeeCode = "";
        }
        dataEmployeeShift.push({
          employee_no: employeeCode,
          shift_code: shiftCode
        });
      });
      return dataEmployeeShift;
    },
    //Lấy danh dách Sheet ca làm việc
    async fn_shift() {
      let dataShift = [];
      const shiftApires = await ShiftApi.GetWorksheetShiftOptions({
        company_id: this.search_company_id,
        shift_ids: this.mData.listShiftIds,
        limit: this.mData.listShiftIds.length || 100000
      });
      shiftApires.result.forEach(e => {
        e.applied_start_time = MethodService.formatDate(
          e.applied_start_time,
          "date"
        );
        e.applied_end_time = MethodService.formatDate(
          e.applied_end_time,
          "date"
        );
        let time = "";
        if (
          e.work_days[0].period_time[0].start_time.hour &&
          e.work_days[0].period_time[1].start_time.hour
        ) {
          time =
            (e.work_days[0].period_time[0].start_time.hour < 10
              ? "0" + e.work_days[0].period_time[0].start_time.hour
              : e.work_days[0].period_time[0].start_time.hour) +
            ":" +
            (e.work_days[0].period_time[0].start_time.minute < 10
              ? "0" + e.work_days[0].period_time[0].start_time.minute
              : e.work_days[0].period_time[0].start_time.minute) +
            " - " +
            (e.work_days[0].period_time[1].end_time.hour < 10
              ? "0" + e.work_days[0].period_time[1].end_time.hour
              : e.work_days[0].period_time[1].end_time.hour) +
            ":" +
            (e.work_days[0].period_time[1].end_time.minute < 10
              ? "0" + e.work_days[0].period_time[1].end_time.minute
              : e.work_days[0].period_time[1].end_time.minute);
        } else if (e.work_days[0].period_time[0].start_time.hour) {
          time =
            (e.work_days[0].period_time[0].start_time.hour < 10
              ? "0" + e.work_days[0].period_time[0].start_time.hour
              : e.work_days[0].period_time[0].start_time.hour) +
            ":" +
            (e.work_days[0].period_time[0].start_time.minute < 10
              ? "0" + e.work_days[0].period_time[0].start_time.minute
              : e.work_days[0].period_time[0].start_time.minute) +
            " - " +
            (e.work_days[0].period_time[0].end_time.hour < 10
              ? "0" + e.work_days[0].period_time[0].end_time.hour
              : e.work_days[0].period_time[0].end_time.hour) +
            ":" +
            (e.work_days[0].period_time[0].end_time.minute < 10
              ? "0" + e.work_days[0].period_time[0].end_time.minute
              : e.work_days[0].period_time[0].end_time.minute);
        } else {
          time = "";
        }
        e.work_hour_number = time;
      });
      dataShift = shiftApires.result;
      return dataShift;
    },
    //Lấy danh sách nhân viên
    async fn_employeeList(data) {
      let dataEmployee = [];
      data.forEach(item => {
        let brach = "";
        let department = "";
        let position = "";
        let contractType = "";
        let coefficientSalary = "";
        let rankSalary = "";
        let dependentPerson = "";
        let curentTime = new Date().getTime();
        let arrNameChucVu = [];
        let arrNamePhongBan = [];
        let arrNameChiNhanh = [];
        let validJobInfo = (item.job_info || []).filter((e) => {
          if (e.end_date) {
            return (
              new Date(e.start_date).getTime() <= curentTime &&
              curentTime <= new Date(e.end_date).getTime()
            );
          } else {
            return new Date(e.start_date).getTime() <= curentTime;
          }
        });
        validJobInfo.forEach(e => {
          let chucVu = this.mData.dataDefault.listChucVu.find((element) => {
            return element.id == e.position_id
          });
          let phongBan = this.mData.dataDefault.listPhongBan.find((element) => {
            return element.id == e.department_id
          });
          let chiNhanh = this.mData.dataDefault.listChiNhanh.find((element) => {
            return element.id == e.branch_id
          });
          if (chucVu && chucVu.name) arrNameChucVu.push(chucVu.name);
          if (phongBan && phongBan.name) arrNamePhongBan.push(phongBan.name);
          if (chiNhanh && chiNhanh.name) arrNameChiNhanh.push(chiNhanh.name);
        })
        item.position_name = arrNameChucVu.length > 0 ? `- ${arrNameChucVu.join(`\r\n- `)}` : "" ;
        item.department_name = arrNamePhongBan.length > 0 ? `- ${arrNamePhongBan.join(`\r\n- `)}` : "" ;
        item.branch_name = arrNameChiNhanh.length > 0 ? `- ${arrNameChiNhanh.join(`\r\n- `)}` : "" ;
        // let validJobInfo = item.job_info.filter(e => {
        //   if (e.end_date) {
        //     return (
        //       new Date(e.start_date).getTime() <= curentTime &&
        //       curentTime <= new Date(e.end_date).getTime()
        //     );
        //   } else {
        //     return new Date(e.start_date).getTime() <= curentTime;
        //   }
        // });
        // let Branch = this.mData.dataDefault.listBranch.find(e => {
        //   return (
        //     e.id ==
        //     (validJobInfo[0] && validJobInfo[0].branch_id
        //       ? validJobInfo[0].branch_id
        //       : "")
        //   );
        // });
        // let Department = this.mData.dataDefault.listDepartment.find(e => {
        //   return (
        //     e.id ==
        //     (validJobInfo[0] && validJobInfo[0].department_id
        //       ? validJobInfo[0].department_id
        //       : "")
        //   );
        // });
        // let Position = this.mData.dataDefault.listPosition.find(e => {
        //   return (
        //     e.id ==
        //     (validJobInfo[0] && validJobInfo[0].position_id
        //       ? validJobInfo[0].position_id
        //       : "")
        //   );
        // });
        // let ContractType = this.mData.dataDefault.listContractType.find(e => {
        //   return (
        //     e.id ==
        //     (validJobInfo[0] && validJobInfo[0].contract_type_id
        //       ? validJobInfo[0].contract_type_id
        //       : "")
        //   );
        // });
        // let dependentPerson = item.dependent_person_info ? item.dependent_person_info.length : 0;
        // let CoefficientSalary = this.mData.dataDefault.listCoefficientSalary.find(
        //   e => {
        //     return (
        //       e.id ==
        //       (item.salary && item.salary.coefficient_salary_id
        //         ? item.salary.coefficient_salary_id
        //         : "")
        //     );
        //   }
        // );
        // let RankSalary = this.mData.dataDefault.listRankSalary.find(e => {
        //   return (
        //     e.id ==
        //     (item.salary && item.salary.rank_salary_id
        //       ? item.salary.rank_salary_id
        //       : "")
        //   );
        // });
        // if (Branch && Branch.name) {
        //   brach = Branch.name;
        // } else {
        //   brach = "";
        // }
        // if (Department && Department.name) {
        //   department = Department.name;
        // } else {
        //   department = "";
        // }
        // if (Position && Position.name) {
        //   position = Position.name;
        // } else {
        //   position = "";
        // }
        // if (ContractType && ContractType.name) {
        //   contractType = ContractType.name;
        // } else {
        //   contractType = "";
        // }
        // if (CoefficientSalary && CoefficientSalary.name) {
        //   coefficientSalary = CoefficientSalary.name;
        // } else {
        //   coefficientSalary = "";
        // }
        // if (RankSalary && RankSalary.name) {
        //   rankSalary = RankSalary.name;
        // } else {
        //   rankSalary = "";
        // }
        dataEmployee.push({
          employee_no: item.employee_no ? item.employee_no : "",
          employee_name:
            item.administrative_info &&
            item.administrative_info.name &&
            item.administrative_info.name.full_name
              ? item.administrative_info.name.full_name
              : "",
          branch_name: brach,
          department_name: department,
          position_name: position,
          contract_type: contractType,
          dependent_rerson: dependentPerson,
          coefficient_salary: coefficientSalary,
          rank_salary: rankSalary
        });
      });

      return dataEmployee;
    },
    async importWork() {
      let data = {
        SalaryPeriodId: this.mData.tableRules.dataSearchSalaryPeriod.value
          .salary_period_id,
        WorkDatas: this.mData.dataExcel
      };
      try {
        const res = await WorkApi.importWork(data);
        if (!res.result.success || res.result.listErrors.length > 0) {
          this.mData.dataDefault.listErrorImport = res.result.listErrors;
          this.exportFileErrorImport(this.mData.dataDefault.listErrorImport);
          window.toastr.error("Import công thất bại!");
          this.dialogErrorVisible = true;
          this.mData.isInvalid = true;
          this.fn_removeWorkFile();
        } else {
          this.closeDialogVisibleWork();
          window.toastr.success("Import công thành công!");
          // this.fn_initTable();
        }
      } catch (error) {
        console.log("error", error);
        window.toastr.error("Import công thất bại!");
      }
    },
    async fn_readFileExcel(file) {
      this.mData.dataExcelBody = [];
      this.mData.dataExcel = [];
      let valueFile = await MethodService.readExcel(file.raw);
      this.mData.dataExcelHeader = [
        "employeeNo",
        "startDate",
        "endDate",
        "shiftCode",
        "shiftName",
        "reason"
      ];
      this.mData.dataExcelBody = valueFile.splice(1, valueFile.length);
      this.mData.dataExcelBody.forEach(e => {
        e[1] = e[1] != undefined ? new Date(e[1]) : e[1];
        e[2] = e[2] != undefined ? new Date(e[2]) : e[2];
      });

      this.mData.isInvalid = false;
      this.mData.dataExcelBody.forEach(item => {
        let obj = {};

        if (
          !moment(moment(item[1]).toISOString()).isValid() ||
          this.formatDate(item[1]) == "Invalid date" ||
          !moment(moment(item[2]).toISOString()).isValid() ||
          this.formatDate(item[2]) == "Invalid date" ||
          !item[3] ||
          !item[0] ||
          !item[5]
        ) {
          this.mData.isInvalid = true;
        }
        if (moment(moment(item[1]).toISOString()).isValid()) {
          let newDateItem = new Date(moment(moment(item[1]).toISOString())._i).getTime();
          if (newDateItem > new Date().getTime()) {
            this.mData.isInvalid = true;
          }
        }
        if (moment(moment(item[2]).toISOString()).isValid()) {
          let newDateItem = new Date(moment(moment(item[1]).toISOString())._i).getTime();
          if (newDateItem > new Date().getTime()) {
            this.mData.isInvalid = true;
          }
        }
        if (
            moment(moment(item[1]).toISOString()).isValid() &&
            moment(moment(item[2]).toISOString()).isValid()
          ) {
            let newDateItem1 = new Date(moment(moment(item[1]).toISOString())._i).getTime();
            let newDateItem2 = new Date(moment(moment(item[2]).toISOString())._i).getTime();
            if (newDateItem1 > newDateItem2) {
              this.mData.isInvalid = true;
            }
          }
        item.forEach((e, i) => {
          obj[this.mData.dataExcelHeader[i]] =
            ((i == 1 || i== 2) && e != undefined) ? MethodService.minus7hour(e) :
              i == 0 && e != undefined ? e.toString().toUpperCase() : e;
        });
        this.mData.dataExcel.push(obj);
      });
    },
    async fn_updaloadWorkFile(file, fileList) {
      if (
        file &&
        file.raw &&
        file.raw.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        window.toastr.error("File phải có định dạng là .xlsx hoặc .xls");
        this.mData.fileUploadOption.File.fileList = [];
        return
      }
      await this.fn_readFileExcel(file);
      if (fileList.length > 1) {
        this.mData.fileUploadOption.File.fileList = [];
        this.mData.fileUploadOption.File.fileList.push(fileList[1]);
      } else {
        this.mData.fileUploadOption.File.fileList = fileList;
      }
      this.mData.dataDefault.file = file;
      setTimeout(() => {
        this.mData.dataExcelBody.forEach((item, index) => {
          if (
            !moment(moment(item[1]).toISOString()).isValid() ||
            !moment(moment(item[2]).toISOString()).isValid() ||
            !item[3] ||
            !item[0] ||
            !item[5]
          ) {
            document
              .getElementsByTagName("tbody")[2]
              .children[index].classList.add("error-row");
          }
          if (moment(moment(item[1]).toISOString()).isValid()) {
            let newDateItem = new Date(moment(moment(item[1]).toISOString())._i).getTime();
            if (newDateItem > new Date().getTime()) {
              document
              .getElementsByTagName("tbody")[2]
              .children[index].classList.add("error-row");
            }
          }
          if (moment(moment(item[2]).toISOString()).isValid()) {
            let newDateItem = new Date(moment(moment(item[1]).toISOString())._i).getTime();
            if (newDateItem > new Date().getTime()) {
              document
              .getElementsByTagName("tbody")[2]
              .children[index].classList.add("error-row");
            }
          }
          if (
            moment(moment(item[1]).toISOString()).isValid() &&
            moment(moment(item[2]).toISOString()).isValid()
          ) {
            let newDateItem1 = new Date(moment(moment(item[1]).toISOString())._i).getTime();
            let newDateItem2 = new Date(moment(moment(item[2]).toISOString())._i).getTime();
            if (newDateItem1 > newDateItem2) {
              document
              .getElementsByTagName("tbody")[2]
              .children[index].classList.add("error-row");
            }
          }
        });
      }, 200);
    },
    fn_removeWorkFile() {
      this.mData.fileUploadOption.File.fileList = [];
      this.mData.dataExcel = [];
    },
    formatDate(value) {
      return MethodService.formatDate(value, "date");
    },
    formatDateUTC(value) {
      return MethodService.formatDateUTC(value, "date");
    },
    formatDateTimeUTC(value) {
      if (!value) return;
      return MethodService.formatDate(value, "datetime");
    },
    closeDialogVisibleWork() {
      this.dialogVisibleWork = false;
      this.mData.dataExcel = [];
      this.mData.fileUploadOption.File.fileList = [];
    },
    closeDialogDetail() {
      this.visibleDialogDetail = false;
      this.showMoreRequest = true;
      this.editingWorkValue = false;
      this.reasonChangeInvalid = false;
      this.workChangeHistory = [];
    },
    fn_startEditWorkValue() {
      this.tempWorkValue = parseFloat(this.mData.dataDetailWork.work_value) || 0;
      this.tempWorkReason = "";
      this.reasonChangeInvalid = false;
      this.editingWorkValue = true;
    },
    async fn_saveWorkValue() {
      if (!this.mData.dataDetailWork.id) {
        window.toastr.error("Không thể cập nhật công vì chưa có bản ghi công cho ngày này");
        return;
      }
      const reasonChange = (this.tempWorkReason || "").trim();
      if (!reasonChange) {
        this.reasonChangeInvalid = true;
        window.toastr.error("Vui lòng nhập lý do thay đổi");
        return;
      }
      try {
        await WorkApi.saveWorkChange({
          id: this.mData.dataDetailWork.id,
          work_id: this.mData.dataDetailWork.id,
          work_value: parseFloat(this.tempWorkValue),
          reason_change: reasonChange
        });
        this.mData.dataDetailWork.work_value = this.tempWorkValue;
        this.editingWorkValue = false;
        this.reasonChangeInvalid = false;
        this.fn_getDataWorkByEmployeeId();
        // WorkChangeHistoryApi.list({ filters: `work_id=${this.mData.dataDetailWork.id}` })
        //   .then(res => { this.workChangeHistory = res.result || []; })
        //   .catch(() => {});
        window.toastr.success("Cập nhật công ghi nhận thành công");
      } catch (error) {
        console.log("error", error);
        window.toastr.error("Cập nhật công ghi nhận thất bại");
      }
    },
    async fn_submit(type) {
      if (type == "approve") {
        this.$confirm(
          `
                      <p>Bạn có chắc chắn muốn chốt bảng công này không?</p>
                      <p style="margin-top: 5px;">
                      <i>(Sau khi chốt hệ thống sẽ không thực hiện tổng hợp công của tháng này kể từ thời điểm chốt)</i>
                    `,
          "Thông báo",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            let data = {
              salary_period_id: this.mData.tableRules.dataSearchSalaryPeriod
                .value.salary_period_id
            };
            try {
              const response = await WorkApi.ApproveAllWorkBySalaryPeriod(data);
              const result = response && response.result;
              if (!result || result.success !== true) {
                window.toastr.warning(
                  result && result.message
                    ? result.message
                    : "Không thể chốt bảng công!"
                );
                return;
              }
              // this.mData.workSealedStatus = true;
              await this.fn_getDataWorkByEmployeeId();
              window.toastr.success("Chốt bảng công thành công!");
            } catch (error) {
              window.toastr.error("Chốt bảng công thất bại!");
            }
          })
          .catch(() => {});
      }
      if (type == "un_approve") {
        this.$confirm(
          "Bạn có chắc chắn muốn hủy chốt bảng công này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info"
          }
        )
          .then(async () => {
            let data = {
              salary_period_id: this.mData.tableRules.dataSearchSalaryPeriod
                .value.salary_period_id
            };
            try {
              await WorkApi.UpApproveAllWorkBySalaryPeriod(data);
              // this.mData.workSealedStatus = false;
              await this.fn_getDataWorkByEmployeeId();
              window.toastr.success("Hủy chốt bảng công thành công!");
            } catch (error) {
              window.toastr.error("Hủy chốt bảng công thất bại!");
            }
          })
          .catch(() => {});
      }
    },
    async fn_hashUrl() {
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(
            this.mData.tableRules.dataSearch.value,
            "condition",
            decodeURIComponent(m1[1])
          );
        }
      }
      if (this.$route.query.salaryPeriodId || this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id) {
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id = this.$route.query.salaryPeriodId ? this.$route.query.salaryPeriodId : this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id;
        // this.fn_changeSalaryPeriod();
        this.fn_defaultSearch();
      }
      if (this.$route.query.viewType) {
        this.mData.timeView = this.$route.query.viewType;
      }
      if (this.$route.query.date) {
        this.mData.day = new Date(
          MethodService.formatterMMDDYYYY(this.$route.query.date)
        ).toString();
        this.hashUrlDay = true;
        this.changeDate();
      }

    },
    fn_seeMore(employee_id, shift_id, date, employeeRequests) {
      let currentDate = new Date(MethodService.formatterMMDDYYYY(date));
      let datePlus12H = currentDate.setHours(currentDate.getHours() + 12);
      let day = new Date(MethodService.formatterMMDDYYYY(date)).getDate();
      let month = new Date(MethodService.formatterMMDDYYYY(date)).getMonth();
      let year = new Date(MethodService.formatterMMDDYYYY(date)).getFullYear();

      let moreRequest = this.mData.dataDefault.listEmployeeRequestDetail.filter(
        e => {
          let dayOff = null;
          if (e.day_off) {
            dayOff = e.day_off.find(x => {
              return (
                x.odd_shifts.includes(1) &&
                x.shift_id == shift_id &&
                new Date(x.day).getDate() == day &&
                new Date(x.day).getMonth() == month &&
                new Date(x.day).getFullYear() == year
              );
            });
          }
          return (
            e.employee_id == employee_id &&
            ((e.shift_go_late == shift_id &&
              new Date(e.extra_minute_go_late).getDate() == day &&
              new Date(e.extra_minute_go_late).getMonth() == month &&
              new Date(e.extra_minute_go_late).getFullYear() == year) ||
              (e.shift_go_home == shift_id &&
                new Date(e.extra_minute_go_home).getDate() == day &&
                new Date(e.extra_minute_go_home).getMonth() == month &&
                new Date(e.extra_minute_go_home).getFullYear() == year) ||
              (e.shift_go_out == shift_id &&
                new Date(e.start_date_go_out).getDate() == day &&
                new Date(e.start_date_go_out).getMonth() == month &&
                new Date(e.start_date_go_out).getFullYear() == year) ||
              (e.day_off && dayOff) ||
              (e.shift_work_online == shift_id &&
                new Date(e.online_date).getDate() == day &&
                new Date(e.online_date).getMonth() == month &&
                new Date(e.online_date).getFullYear() == year)||
              (e.shift_work_add == shift_id &&
                new Date(e.end_date_work_add).getDate() == day &&
                new Date(e.end_date_work_add).getMonth() == month &&
                new Date(e.end_date_work_add).getFullYear() == year) ||
              (new Date(e.start_date_bussiness).getTime() <= datePlus12H &&
                new Date(e.end_date_bussiness).getTime() >= datePlus12H))
          );
        }
      );
      if (moreRequest.length > 0) {
        this.loadEmployeeRequest = false;
        this.mData.dataDetailWork.requests = [];
        moreRequest.forEach(e => {
          let obj = {
            id: e.id,
            title: e.title ? e.title : e.content,
            status: e.status
          };
          // let checkHaveRequest = moreRequest.filter(e => {
          //   return this.mData.dataDetailWork.requests.includes(e.id)
          // })
          this.mData.dataDetailWork.requests.push(obj);
        });
        this.loadEmployeeRequest = true;
      }
      this.showMoreRequest = false;
    },
    async exportFileErrorImport(dataError){
      let workbook = MethodService.createWookbook();
      let worksheet = workbook.addWorksheet("Bản ghi lỗi", {
        views: [{ state: "frozen", ySplit: 1 }]
      });

      worksheet.columns = [
        { header: "Mã nhân viên", key: "employeeNo", width: 20 },
        { header: "Thời điểm từ", key: "startDate", width: 20 },
        { header: "Thời điểm đến", key: "endDate", width: 20 },
        { header: "Mã ca", key: "shiftCode", width: 20 },
        { header: "Tên ca", key: "shiftName", width: 35 },
        { header: "Lý do", key: "reason", width: 50 },
        { header: "Lỗi", key: "messages", width: 55 }
      ];

      window.$.each(dataError, (index, element) => {
        let item = {};
        item.employeeNo = element.employeeNo;
        item.startDate = MethodService.formatDate(element.startDate, "datetime");
        item.endDate = MethodService.formatDate(element.endDate, "datetime");
        item.shiftCode = element.shiftCode;
        item.shiftName = element.shiftName;
        item.reason = element.reason;
        item.messages = `- ${element.messages.join(`\r\n- `)}`;
        worksheet.addRow(item);
      });

      worksheet.getRow(1).height = 20;
      worksheet.eachRow({ includeEmpty: true },(row, rowNumber) => {
        row.eachCell(function(cell, colNumber) {
          if (rowNumber == 1) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFE162" }
            };
            cell.font = { bold: true };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true
            };
          } else {
            if (colNumber == 1 || colNumber == 2 || colNumber == 3 || colNumber == 4) {
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true
              };
            } else {
              cell.alignment = {
                vertical: "middle",
                wrapText: true
              };
            }
          }
          // Set border of each cell
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
        });
      });
      await MethodService.addAnotherSheet(workbook,this.mData.dataDefault.listShift , "Shift", ["Mã ca","Tên ca"]);
      worksheet
      .getColumn("D")
      .eachCell({ includeEmpty: true }, function(cell, rowNumber) {
        if (rowNumber != 1) {
          cell.dataValidation = {
            type: "list",
            allowBlank: true,
            formulae: ["Shift!$A$2:$A$2000"]
          };
        }
      });
      worksheet
      .getColumn("E")
      .eachCell({ includeEmpty: true }, function(cell, rowNumber) {
        if (rowNumber != 1) {
          cell.value = { formula: `IF(D${rowNumber} = "", "", VLOOKUP(D${rowNumber},Shift!$A$2:$B$2000,2,0))`}
        }
      });
      workbook.xlsx.writeBuffer().then(function(data) {
        var blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, `Lỗi nhập dữ liệu công.xlsx`);
      });
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    canAccessHistory() {
      const codes = ["FT901", "FT902", "FT1001", "FT1003", "FT1004", "FT1006", "FT1007"];
      const features = this.mData.dataDefault.listFeature || [];
      return codes.some((code) => features.includes(code));
    },
    fn_goToWorkChangeHistory() {
      this.$router.push({ name: "Admin-Timekeeping-TimekeepingConfig-WorkChangeHistory-list" });
    },
  },
  async created() {
    this.loading = true;
    this.mData.currentDate = MethodService.getCurrentDate();
    await this.fn_initDataDefault();
    this.mData.day = new Date();
    await this.fn_hashUrl();
  }
};
</script>

<style lang="scss" scoped>
.salary_period{
  width: 250px;
}
::v-deep .salary_period.el-select .el-select__tags {
  transform: translateY(-50%);
}
.el-button--default.is-disabled{
  text-align: center;
  color: var(--orange);
  background: var(--white);
  border-radius: 10px;
  border: 1px solid var(--orange);
}
.row {
  margin-left: -15px;
  margin-right: -15px;
}
.asterisk {
  font-size: 7px;
  color: red;
  position: absolute;
}
.required {
  color: #f56c6c !important;
}
::v-deep .work-reason-input.is-invalid .el-textarea__inner {
  border-color: #f56c6c !important;
}
.work-reason-error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
}
.el-button span {
  text-align: center !important;
}
::v-deep .el-dialog__header{
  padding: 8px 10px;
}
.el-dialog__body {
  word-break: break-word;
  .el-button--medium.is-round {
    padding: 5px 25px;
    font-size: 13px;
  }
}
.work_information{
  margin-right: 29px;
}
.name p{
  display: block;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name p,.date p{
  color: var(--white) !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.el-dialog__body span{
  color: #000 !important;
}
.ml-32px {
  margin-left: 32px;
}
.al-center {
  align-items: center;
}
::v-deep .fa-file-download:before {
  color: #4baafb;
}
::v-deep .el-table__row {
  background-color: #fff !important;
}
.status {
  display: inline;
  margin-left: 10px;
  font-size: 15px;
  color: #606060;
  font-family: UTM Avo;
}
.check_icon {
  width: 20px;
  position: absolute;
  top: 13px;
  right: 10px;
}
::v-deep .el-date-editor .el-input__inner {
  padding-right: 10px;
}
.card-body {
  padding-top: 15px;
}
::v-deep .el-form-item {
  white-space: nowrap;
  margin-bottom: 0px;
}
::v-deep .weeekend {
  background-color: rgb(232, 232, 232) !important;
  border-color: rgb(216, 216, 216) !important;
}

::v-deep .off_day {
  background-color: #00D1FF !important;
  border-color: #d9eced !important;
}
::v-deep .table thead th {
  text-align: center;
  vertical-align: middle;
  border-bottom-width: 1px;
  padding: 10px;
  font-weight: 600;
  font-size: 14px;
}
::v-deep .table-responsive {
  margin-bottom: 0;
}
.d-flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button-save {
  margin-right: 30px;
}
.div-upload {
  max-width: 360px;
  margin: 0 auto;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
::v-deep .text-left .disabled {
  color: gray;
}
::v-deep .text-left .disabled:hover {
  cursor: no-drop;
}
::v-deep .error-row {
  background-color: #ffd7d7 !important;
}
::v-deep .error-row:hover {
  background-color: #ffd7d7 !important;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
  word-break: break-word;
}
::v-deep ul {
  margin-bottom: 0;
  padding-left: 10px;
}
.circle-note-work-table:hover {
  cursor: pointer;
}
.request {
  width: 110px;
}
ul {
  list-style-type: circle;
  word-break: break-word;
  padding-left: 30px;
}
::v-deep .el-table__body-wrapper {
  max-height: calc(100vh - 340px);
  overflow-y: auto;
  width: 100%;
}
.date-table {
  max-width: 800px;
}
::v-deep .el-table__header-wrapper .cell .el-checkbox .el-checkbox__input {
  left: 0px;
  top: 3px;
}
::v-deep .el-table__body-wrapper .cell .el-checkbox .el-checkbox__input {
  left: 4px;
  top: 3px;
}
::v-deep .poper_cus {
  z-index: 3049 !important;
  position: absolute !important;
  top: 114px !important;
  right: 20px !important;
}
.see_more {
  color: #1597e5;
  font-weight: bold;
  font-style: italic;
}
.see_more:hover {
  cursor: pointer;
}
.worksheet-number-cell {
  cursor: pointer;
}
::v-deep .el-date-editor {
  width: 250px;
}
.note-circle {
  max-width: 800px;
}
@media (max-width: 1220px) {
  .body-header {
    flex-direction: column;
    justify-content: space-between;
  }
  .button-div {
    margin-top: 10px;
    text-align: right;
  }
}
@media (max-width: 670px) {
}
@media (max-width: 530px) {
  .at-center {
    flex-direction: column;
    align-items: inherit;
  }
  .ml-4 {
    margin-top: 5px;
    margin-left: 0 !important;
  }
  .status {
    margin-top: 5px;
    margin-left: 0;
    display: inline;
    font-size: 15px;
    color: #606060;
    font-family: UTM Avo;
  }
}
</style>
